// This file is auto-generated by @hey-api/openapi-ts

import { type Client, type Options as Options2, type TDataShape, urlSearchParamsBodySerializer } from './client';
import { client } from './client.gen';
import type { AddPolicyToRoleData, AddPolicyToRoleErrors, AddPolicyToRoleResponses, AdminDiscardDraftData, AdminDiscardDraftErrors, AdminDiscardDraftResponses, AdminGetApiKeyRolesData, AdminGetApiKeyRolesErrors, AdminGetApiKeyRolesResponses, AdminGetDraftData, AdminGetDraftErrors, AdminGetDraftResponses, AdminGetUserRolesData, AdminGetUserRolesErrors, AdminGetUserRolesResponses, AdminGetVersionData, AdminGetVersionErrors, AdminGetVersionResponses, AdminListAgreementsData, AdminListAgreementsErrors, AdminListAgreementsResponses, AdminPublishCustomData, AdminPublishCustomErrors, AdminPublishCustomResponses, AdminPublishFromDraftData, AdminPublishFromDraftErrors, AdminPublishFromDraftResponses, AdminRevertToDefaultData, AdminRevertToDefaultErrors, AdminRevertToDefaultResponses, AdminSaveDraftData, AdminSaveDraftErrors, AdminSaveDraftResponses, AdminUpdateApiKeyRolesData, AdminUpdateApiKeyRolesErrors, AdminUpdateApiKeyRolesResponses, AppleNativeLoginData, AppleNativeLoginErrors, AppleNativeLoginResponses, ApplyInvoiceData, ApplyInvoiceErrors, ApplyInvoiceResponses, AssignPermissionToRoleData, AssignPermissionToRoleErrors, AssignPermissionToRoleResponses, AssignRolesToUserData, AssignRolesToUserErrors, AssignRolesToUserResponses, AssignUserPermissionData, AssignUserPermissionErrors, AssignUserPermissionResponses, BatchUpdateEntitlementMappingsData, BatchUpdateEntitlementMappingsErrors, BatchUpdateEntitlementMappingsResponses, BatchUpsertRealmConfigsData, BatchUpsertRealmConfigsErrors, BatchUpsertRealmConfigsResponses, CancelPaymentAttemptData, CancelPaymentAttemptErrors, CancelPaymentAttemptResponses, CancelSubscriptionForClientAppData, CancelSubscriptionForClientAppErrors, CancelSubscriptionForClientAppResponses, ChangeEmailConfirmData, ChangeEmailConfirmErrors, ChangeEmailConfirmResponses, ChangeEmailRequestData, ChangeEmailRequestErrors, ChangeEmailRequestResponses, ChangeUserPasswordData, ChangeUserPasswordErrors, ChangeUserPasswordResponses, CheckPermission2Data, CheckPermission2Errors, CheckPermission2Responses, CheckPermissionData, CheckPermissionErrors, CheckPermissionResponses, ConsumePointsExtData, ConsumePointsExtErrors, ConsumePointsExtResponses, CreateApiKeyData, CreateApiKeyErrors, CreateApiKeyResponses, CreateClientApp2Data, CreateClientApp2Errors, CreateClientApp2Responses, CreateClientAppData, CreateClientAppErrors, CreateClientAppResponses, CreateCreditBucketHandlerData, CreateCreditBucketHandlerErrors, CreateCreditBucketHandlerResponses, CreateCreditNoteData, CreateCreditNoteErrors, CreateCreditNoteResponses, CreateEntitlementMappingData, CreateEntitlementMappingErrors, CreateEntitlementMappingResponses, CreateInvoiceData, CreateInvoiceErrors, CreateInvoiceResponses, CreateOauthConfigData, CreateOauthConfigErrors, CreateOauthConfigResponses, CreatePaymentAttemptData, CreatePaymentAttemptErrors, CreatePaymentAttemptResponses, CreatePermissionDefinitionData, CreatePermissionDefinitionErrors, CreatePermissionDefinitionResponses, CreateRealm2Data, CreateRealm2Errors, CreateRealm2Responses, CreateRealmData, CreateRealmErrors, CreateRealmResponses, CreateRoleData, CreateRoleErrors, CreateRoleResponses, CreateUser2Data, CreateUser2Errors, CreateUser2Responses, CreateUserData, CreateUserErrors, CreateUserResponses, CreemWebhookHandlerData, CreemWebhookHandlerErrors, CreemWebhookHandlerResponses, DeleteAccountData, DeleteAccountErrors, DeleteAccountResponses, DeleteApiKeyData, DeleteApiKeyErrors, DeleteApiKeyResponses, DeleteClientAppData, DeleteClientAppErrors, DeleteClientAppResponses, DeleteCreditBucketHandlerData, DeleteCreditBucketHandlerErrors, DeleteCreditBucketHandlerResponses, DeleteOauthConfigData, DeleteOauthConfigErrors, DeleteOauthConfigResponses, DeletePermissionData, DeletePermissionErrors, DeletePermissionResponses, DeleteRealmConfigData, DeleteRealmConfigErrors, DeleteRealmConfigResponses, DeleteRoleData, DeleteRoleErrors, DeleteRoleResponses, DeleteUserData, DeleteUserErrors, DeleteUserResponses, DeviceAuthorizeData, DeviceAuthorizeErrors, DeviceAuthorizeResponses, DeviceConfirmData, DeviceConfirmErrors, DeviceConfirmResponses, DeviceTokenData, DeviceTokenErrors, DeviceTokenResponses, DeviceVerifyData, DeviceVerifyErrors, DeviceVerifyResponses, DownloadInvoicePdfData, DownloadInvoicePdfErrors, DownloadInvoicePdfResponses, DownloadMyInvoicePdfData, DownloadMyInvoicePdfErrors, DownloadMyInvoicePdfResponses, EmailStatusData, EmailStatusErrors, EmailStatusResponses, EmailTestData, EmailTestErrors, EmailTestResponses, FulfillPaymentData, FulfillPaymentErrors, FulfillPaymentResponses, GetAgreementData, GetAgreementErrors, GetAgreementResponses, GetApiKeyData, GetApiKeyErrors, GetApiKeyResponses, GetAuditEventData, GetAuditEventErrors, GetAuditEventResponses, GetBalanceExtData, GetBalanceExtErrors, GetBalanceExtResponses, GetBucketOverviewHandlerData, GetBucketOverviewHandlerErrors, GetBucketOverviewHandlerResponses, GetClientApp2Data, GetClientApp2Errors, GetClientApp2Responses, GetClientAppData, GetClientAppErrors, GetClientAppResponses, GetConsentStatusData, GetConsentStatusErrors, GetConsentStatusResponses, GetCreditBucketHandlerData, GetCreditBucketHandlerErrors, GetCreditBucketHandlerResponses, GetCurrentUserPermissionsData, GetCurrentUserPermissionsErrors, GetCurrentUserPermissionsResponses, GetDashboardStatsData, GetDashboardStatsErrors, GetDashboardStatsResponses, GetEffectivePermissionsData, GetEffectivePermissionsErrors, GetEffectivePermissionsResponses, GetEntitlementCurrenciesData, GetEntitlementCurrenciesErrors, GetEntitlementCurrenciesResponses, GetEntitlementMappingData, GetEntitlementMappingErrors, GetEntitlementMappingResponses, GetFeatureAvailabilityData, GetFeatureAvailabilityErrors, GetFeatureAvailabilityResponses, GetInvoiceApplyEligibilityData, GetInvoiceApplyEligibilityErrors, GetInvoiceApplyEligibilityResponses, GetInvoiceData, GetInvoiceErrors, GetInvoiceResponses, GetMyInvoiceScopedData, GetMyInvoiceScopedErrors, GetMyInvoiceScopedResponses, GetMySubscriptionHistoryData, GetMySubscriptionHistoryErrors, GetMySubscriptionHistoryResponses, GetOauthConfigData, GetOauthConfigErrors, GetOauthConfigResponses, GetOneTimeMappingsData, GetOneTimeMappingsErrors, GetOneTimeMappingsResponses, GetPaymentAttemptStatusData, GetPaymentAttemptStatusErrors, GetPaymentAttemptStatusResponses, GetPaymentStatsData, GetPaymentStatsErrors, GetPaymentStatsResponses, GetPermissionData, GetPermissionErrors, GetPermissionResponses, GetPointsConsumptionStatsData, GetPointsConsumptionStatsErrors, GetPointsConsumptionStatsResponses, GetProfileData, GetProfileErrors, GetProfileResponses, GetPublicConfigData, GetPublicConfigErrors, GetPublicConfigResponses, GetPurchaseHistoryData, GetPurchaseHistoryErrors, GetPurchaseHistoryResponses, GetRealm2Data, GetRealm2Errors, GetRealm2Responses, GetRealmConfigData, GetRealmConfigErrors, GetRealmConfigResponses, GetRealmData, GetRealmErrors, GetRealmPurchaseHistoryData, GetRealmPurchaseHistoryErrors, GetRealmPurchaseHistoryResponses, GetRealmResponses, GetRegistrationRulesData, GetRegistrationRulesErrors, GetRegistrationRulesResponses, GetRegistrationStatusData, GetRegistrationStatusErrors, GetRegistrationStatusResponses, GetRoleData, GetRoleErrors, GetRolePermissionsData, GetRolePermissionsErrors, GetRolePermissionsResponses, GetRolePoliciesData, GetRolePoliciesErrors, GetRolePoliciesResponses, GetRoleResponses, GetSellerConfigData, GetSellerConfigErrors, GetSellerConfigResponses, GetSignupStatusData, GetSignupStatusErrors, GetSignupStatusResponses, GetSubscription2Data, GetSubscription2Errors, GetSubscription2Responses, GetSubscription3Data, GetSubscription3Errors, GetSubscription3Responses, GetSubscriptionData, GetSubscriptionErrors, GetSubscriptionForClientAppData, GetSubscriptionForClientAppErrors, GetSubscriptionForClientAppResponses, GetSubscriptionHistoryData, GetSubscriptionHistoryErrors, GetSubscriptionHistoryResponses, GetSubscriptionResponses, GetTransactionByExternalRefExtData, GetTransactionByExternalRefExtErrors, GetTransactionByExternalRefExtResponses, GetTransactionExtData, GetTransactionExtErrors, GetTransactionExtResponses, GetTurnstileStatusData, GetTurnstileStatusErrors, GetTurnstileStatusResponses, GetUser2Data, GetUser2Errors, GetUser2Responses, GetUserData, GetUserErrors, GetUserFeatureAvailabilityData, GetUserFeatureAvailabilityErrors, GetUserFeatureAvailabilityResponses, GetUserPermissionsData, GetUserPermissionsErrors, GetUserPermissionsResponses, GetUserResponses, GetUserRolesData, GetUserRolesErrors, GetUserRolesResponses, GetWalletData, GetWalletErrors, GetWalletResponses, GoogleOneTapData, GoogleOneTapErrors, GoogleOneTapResponses, GrantPointsData, GrantPointsErrors, GrantPointsExtData, GrantPointsExtErrors, GrantPointsExtResponses, GrantPointsResponses, HandleAppleWebhookData, HandleAppleWebhookResponses, HandleBeginPasskeyRegistrationData, HandleBeginPasskeyRegistrationErrors, HandleBeginPasskeyRegistrationResponses, HandleBeginReauthData, HandleBeginReauthErrors, HandleBeginReauthResponses, HandleCustomDomainAuthorizeData, HandleCustomDomainAuthorizeErrors, HandleCustomDomainAuthorizeResponses, HandleDeletePasskeyCredentialData, HandleDeletePasskeyCredentialErrors, HandleDeletePasskeyCredentialResponses, HandleDisableTotpData, HandleDisableTotpErrors, HandleDisableTotpResponses, HandleDiscardWhiteLabelDraftData, HandleDiscardWhiteLabelDraftErrors, HandleDiscardWhiteLabelDraftResponses, HandleEnableTotpData, HandleEnableTotpErrors, HandleEnableTotpResponses, HandleFinishPasskeyRegistrationData, HandleFinishPasskeyRegistrationErrors, HandleFinishPasskeyRegistrationResponses, HandleGetCustomDomainConfigData, HandleGetCustomDomainConfigErrors, HandleGetCustomDomainConfigResponses, HandleGetRealmEmailOtpConfigData, HandleGetRealmEmailOtpConfigErrors, HandleGetRealmEmailOtpConfigResponses, HandleGetRealmPasskeyConfigData, HandleGetRealmPasskeyConfigErrors, HandleGetRealmPasskeyConfigResponses, HandleGetRealmTotpConfigData, HandleGetRealmTotpConfigErrors, HandleGetRealmTotpConfigResponses, HandleGetTotpStatusData, HandleGetTotpStatusErrors, HandleGetTotpStatusResponses, HandleGetWhiteLabelConfigData, HandleGetWhiteLabelConfigErrors, HandleGetWhiteLabelConfigResponses, HandleListPasskeyCredentialsData, HandleListPasskeyCredentialsErrors, HandleListPasskeyCredentialsResponses, HandlePasskey2FaOptionsData, HandlePasskey2FaOptionsErrors, HandlePasskey2FaOptionsResponses, HandlePasskey2FaVerifyData, HandlePasskey2FaVerifyErrors, HandlePasskey2FaVerifyResponses, HandlePasskeyOptionsData, HandlePasskeyOptionsErrors, HandlePasskeyOptionsResponses, HandlePasskeyVerifyData, HandlePasskeyVerifyErrors, HandlePasskeyVerifyResponses, HandlePublishWhiteLabelConfigData, HandlePublishWhiteLabelConfigErrors, HandlePublishWhiteLabelConfigResponses, HandleRegenerateTotpData, HandleRegenerateTotpErrors, HandleRegenerateTotpResponses, HandleRenamePasskeyCredentialData, HandleRenamePasskeyCredentialErrors, HandleRenamePasskeyCredentialResponses, HandleRestoreWhiteLabelConfigData, HandleRestoreWhiteLabelConfigErrors, HandleRestoreWhiteLabelConfigResponses, HandleSaveWhiteLabelDraftData, HandleSaveWhiteLabelDraftErrors, HandleSaveWhiteLabelDraftResponses, HandleUpdateCustomDomainConfigData, HandleUpdateCustomDomainConfigErrors, HandleUpdateCustomDomainConfigResponses, HandleUpdateRealmEmailOtpConfigData, HandleUpdateRealmEmailOtpConfigErrors, HandleUpdateRealmEmailOtpConfigResponses, HandleUpdateRealmPasskeyConfigData, HandleUpdateRealmPasskeyConfigErrors, HandleUpdateRealmPasskeyConfigResponses, HandleUpdateRealmTotpConfigData, HandleUpdateRealmTotpConfigErrors, HandleUpdateRealmTotpConfigResponses, HandleVerifyReauthData, HandleVerifyReauthErrors, HandleVerifyReauthResponses, HandleVerifyTotpData, HandleVerifyTotpErrors, HandleVerifyTotpResponses, HandleVerifyTotpSetupData, HandleVerifyTotpSetupErrors, HandleVerifyTotpSetupResponses, HealthCheckData, HealthCheckErrors, HealthCheckResponses, IssueInvoiceData, IssueInvoiceErrors, IssueInvoiceResponses, LdapLoginData, LdapLoginErrors, LdapLoginResponses, LdapStatusData, LdapStatusErrors, LdapStatusResponses, ListAgreementsData, ListAgreementsErrors, ListAgreementsResponses, ListApiKeysData, ListApiKeysErrors, ListApiKeysResponses, ListAttributionAnomaliesData, ListAttributionAnomaliesErrors, ListAttributionAnomaliesResponses, ListAuditEventsData, ListAuditEventsErrors, ListAuditEventsResponses, ListClientApps2Data, ListClientApps2Errors, ListClientApps2Responses, ListClientAppsData, ListClientAppsErrors, ListClientAppsResponses, ListCreditBucketsHandlerData, ListCreditBucketsHandlerErrors, ListCreditBucketsHandlerResponses, ListEntitlementMappingsData, ListEntitlementMappingsErrors, ListEntitlementMappingsResponses, ListInvoicesData, ListInvoicesErrors, ListInvoicesResponses, ListMyInvoicesData, ListMyInvoicesErrors, ListMyInvoicesResponses, ListMySubscriptionHistoryData, ListMySubscriptionHistoryErrors, ListMySubscriptionHistoryResponses, ListOauthConfigsData, ListOauthConfigsErrors, ListOauthConfigsResponses, ListOneTimeMappingsData, ListOneTimeMappingsErrors, ListOneTimeMappingsResponses, ListPaymentProvidersData, ListPaymentProvidersErrors, ListPaymentProvidersResponses, ListPermissionsData, ListPermissionsErrors, ListPermissionsResponses, ListPurchaseOptionsData, ListPurchaseOptionsErrors, ListPurchaseOptionsResponses, ListRealmConfigsByTypeData, ListRealmConfigsByTypeErrors, ListRealmConfigsByTypeResponses, ListRealmConfigsData, ListRealmConfigsErrors, ListRealmConfigsResponses, ListRealms2Data, ListRealms2Errors, ListRealms2Responses, ListRealmsData, ListRealmsErrors, ListRealmsPaginatedData, ListRealmsPaginatedErrors, ListRealmsPaginatedResponses, ListRealmsResponses, ListRolesData, ListRolesErrors, ListRolesResponses, ListSubscriptionHistoryData, ListSubscriptionHistoryErrors, ListSubscriptionHistoryResponses, ListSubscriptionsData, ListSubscriptionsErrors, ListSubscriptionsResponses, ListTransactionsData, ListTransactionsErrors, ListTransactionsResponses, ListUsers2Data, ListUsers2Errors, ListUsers2Responses, ListUsersData, ListUsersErrors, ListUserSessionsData, ListUserSessionsErrors, ListUserSessionsResponses, ListUsersResponses, ListUserTransactionsData, ListUserTransactionsErrors, ListUserTransactionsResponses, ListUserWalletsData, ListUserWalletsErrors, ListUserWalletsResponses, ListWalletsData, ListWalletsErrors, ListWalletsResponses, LoginData, LoginErrors, LoginResponses, LogoutData, LogoutErrors, LogoutResponses, MarkPaidData, MarkPaidErrors, MarkPaidResponses, McpClientRegistrationData, McpClientRegistrationErrors, McpClientRegistrationResponses, McpProtectedResourceMetadataData, McpProtectedResourceMetadataErrors, McpProtectedResourceMetadataResponses, OauthAuthorizationServerMetadataData, OauthAuthorizationServerMetadataErrors, OauthAuthorizationServerMetadataResponses, OauthAuthorizeData, OauthAuthorizeErrors, OauthCallbackData, OauthCallbackErrors, OauthCallbackFormData, OauthCallbackFormErrors, OauthCallbackFormResponses, OauthCallbackResponses, OauthLoginData, OauthLoginErrors, OauthLoginResponses, OauthTokenData, OauthTokenErrors, OauthTokenResponses, OidcDiscoveryData, OidcDiscoveryErrors, OidcDiscoveryResponses, OidcJwksData, OidcJwksErrors, OidcJwksResponses, OidcRotateSigningKeyData, OidcRotateSigningKeyErrors, OidcRotateSigningKeyResponses, OidcUserinfoData, OidcUserinfoErrors, OidcUserinfoResponses, PermissionGetUserRolesData, PermissionGetUserRolesErrors, PermissionGetUserRolesResponses, RecordConsentData, RecordConsentErrors, RecordConsentResponses, RefreshData, RefreshErrors, RefreshResponses, RegisterData, RegisterErrors, RegisterResponses, RemovePermissionFromRoleData, RemovePermissionFromRoleErrors, RemovePermissionFromRoleResponses, RemovePolicyFromRoleData, RemovePolicyFromRoleErrors, RemovePolicyFromRoleResponses, RemoveRoleFromUserData, RemoveRoleFromUserErrors, RemoveRoleFromUserResponses, RemoveUserPermissionData, RemoveUserPermissionErrors, RemoveUserPermissionResponses, ResetPasswordConfirmData, ResetPasswordConfirmErrors, ResetPasswordRequestData, ResetPasswordRequestErrors, ResetPasswordRequestResponses, ResetUserPasswordData, ResetUserPasswordErrors, ResetUserPasswordResponses, ResolveCustomDomainData, ResolveCustomDomainErrors, ResolveCustomDomainResponses, ResolveDefaultPriceData, ResolveDefaultPriceErrors, ResolveDefaultPriceResponses, RevokeAllUserSessionsData, RevokeAllUserSessionsErrors, RevokeAllUserSessionsResponses, RevokeUserSessionData, RevokeUserSessionErrors, RevokeUserSessionResponses, RotateApiKeyData, RotateApiKeyErrors, RotateApiKeyResponses, SendData, SendEmailCodeData, SendEmailCodeErrors, SendEmailCodeResponses, SendErrors, SendResponses, SignupData, SignupErrors, SignupResponses, Status2Data, Status2Errors, Status2Responses, Status3Data, Status3Errors, Status3Responses, StatusData, StatusErrors, StatusResponses, StripeWebhookHandlerData, StripeWebhookHandlerErrors, StripeWebhookHandlerResponses, SubmitIapReceiptData, SubmitIapReceiptErrors, SubmitIapReceiptResponses, SwitchClientData, SwitchClientErrors, SwitchClientResponses, SyncProviderProductsData, SyncProviderProductsErrors, SyncProviderProductsResponses, UpdateApiKeyData, UpdateApiKeyErrors, UpdateApiKeyResponses, UpdateClientAppData, UpdateClientAppErrors, UpdateClientAppResponses, UpdateCreditBucketHandlerData, UpdateCreditBucketHandlerErrors, UpdateCreditBucketHandlerResponses, UpdateEntitlementMappingData, UpdateEntitlementMappingErrors, UpdateEntitlementMappingResponses, UpdateInvoiceData, UpdateInvoiceErrors, UpdateInvoiceResponses, UpdateOauthConfigData, UpdateOauthConfigErrors, UpdateOauthConfigResponses, UpdatePermissionData, UpdatePermissionErrors, UpdatePermissionResponses, UpdateProfileData, UpdateProfileErrors, UpdateProfileResponses, UpdateRealmData, UpdateRealmErrors, UpdateRealmResponses, UpdateRoleData, UpdateRoleErrors, UpdateRoleResponses, UpdateUserData, UpdateUserErrors, UpdateUserResponses, UpdateUserRolesData, UpdateUserRolesErrors, UpdateUserRolesResponses, UpdateWalletStatusData, UpdateWalletStatusErrors, UpdateWalletStatusResponses, UpsertRealmConfigData, UpsertRealmConfigErrors, UpsertRealmConfigResponses, UpsertRegistrationRulesData, UpsertRegistrationRulesErrors, UpsertRegistrationRulesResponses, UpsertSellerConfigData, UpsertSellerConfigErrors, UpsertSellerConfigResponses, VerifyData, VerifyEmailConfirmData, VerifyEmailConfirmErrors, VerifyEmailTriggerData, VerifyEmailTriggerErrors, VerifyEmailTriggerResponses, VerifyErrors, VerifyResponses, VoidInvoiceData, VoidInvoiceErrors, VoidInvoiceResponses, WechatCallbackData, WechatCallbackErrors, WechatLoginData, WechatLoginErrors, WechatLoginResponses, WechatMiniprogramLoginData, WechatMiniprogramLoginErrors, WechatMiniprogramLoginResponses, WechatWebhookHandlerData, WechatWebhookHandlerErrors, WechatWebhookHandlerResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * RFC 8414 Authorization Server metadata for the per-realm OAuth issuer
 * behind the MCP resource. Served at the standard path-style well-known
 * insertion (well-known between host and issuer path); the legacy OIDC
 * append-form discovery URL keeps working unchanged.
 */
export const oauthAuthorizationServerMetadata = <ThrowOnError extends boolean = false>(options: Options<OauthAuthorizationServerMetadataData, ThrowOnError>) => (options.client ?? client).get<OauthAuthorizationServerMetadataResponses, OauthAuthorizationServerMetadataErrors, ThrowOnError>({ url: '/.well-known/oauth-authorization-server/api/oauth/{realmId}', ...options });

/**
 * RFC 9728 Protected Resource Metadata for a realm's MCP endpoint.
 */
export const mcpProtectedResourceMetadata = <ThrowOnError extends boolean = false>(options: Options<McpProtectedResourceMetadataData, ThrowOnError>) => (options.client ?? client).get<McpProtectedResourceMetadataResponses, McpProtectedResourceMetadataErrors, ThrowOnError>({ url: '/.well-known/oauth-protected-resource/mcp/{realmId}', ...options });

/**
 * List all API Keys for a realm
 *
 * Returns a paginated list of API keys. Hash and plaintext are never exposed.
 */
export const listApiKeys = <ThrowOnError extends boolean = false>(options?: Options<ListApiKeysData, ThrowOnError>) => (options?.client ?? client).get<ListApiKeysResponses, ListApiKeysErrors, ThrowOnError>({ url: '/api/api-keys', ...options });

/**
 * Create a new API Key
 *
 * Generates a new API key for the specified realm. The plaintext key is returned
 * only in this response and cannot be retrieved later.
 */
export const createApiKey = <ThrowOnError extends boolean = false>(options: Options<CreateApiKeyData, ThrowOnError>) => (options.client ?? client).post<CreateApiKeyResponses, CreateApiKeyErrors, ThrowOnError>({
    url: '/api/api-keys',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete an API Key
 *
 * Permanently deletes an API key.
 */
export const deleteApiKey = <ThrowOnError extends boolean = false>(options: Options<DeleteApiKeyData, ThrowOnError>) => (options.client ?? client).delete<DeleteApiKeyResponses, DeleteApiKeyErrors, ThrowOnError>({ url: '/api/api-keys/{apiKeyId}', ...options });

/**
 * Get a specific API Key by ID
 *
 * Retrieves details of an API key. Hash and plaintext are never exposed.
 */
export const getApiKey = <ThrowOnError extends boolean = false>(options: Options<GetApiKeyData, ThrowOnError>) => (options.client ?? client).get<GetApiKeyResponses, GetApiKeyErrors, ThrowOnError>({ url: '/api/api-keys/{apiKeyId}', ...options });

/**
 * Update an API Key
 *
 * Partially updates an API key's name, enabled status, or expiration.
 */
export const updateApiKey = <ThrowOnError extends boolean = false>(options: Options<UpdateApiKeyData, ThrowOnError>) => (options.client ?? client).put<UpdateApiKeyResponses, UpdateApiKeyErrors, ThrowOnError>({
    url: '/api/api-keys/{apiKeyId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get API Key roles
 *
 * Returns the list of roles assigned to a specific API Key.
 */
export const adminGetApiKeyRoles = <ThrowOnError extends boolean = false>(options: Options<AdminGetApiKeyRolesData, ThrowOnError>) => (options.client ?? client).get<AdminGetApiKeyRolesResponses, AdminGetApiKeyRolesErrors, ThrowOnError>({ url: '/api/api-keys/{apiKeyId}/roles', ...options });

/**
 * Update API Key roles
 *
 * Replaces all roles assigned to an API Key. Empty array clears all roles.
 * Builtin roles cannot be assigned to API Keys (returns 400).
 */
export const adminUpdateApiKeyRoles = <ThrowOnError extends boolean = false>(options: Options<AdminUpdateApiKeyRolesData, ThrowOnError>) => (options.client ?? client).put<AdminUpdateApiKeyRolesResponses, AdminUpdateApiKeyRolesErrors, ThrowOnError>({
    url: '/api/api-keys/{apiKeyId}/roles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Rotate an API Key
 *
 * Generates a new key for the API key, replacing the old hash.
 * The old key is immediately invalidated. Returns the new plaintext key (shown once).
 */
export const rotateApiKey = <ThrowOnError extends boolean = false>(options: Options<RotateApiKeyData, ThrowOnError>) => (options.client ?? client).post<RotateApiKeyResponses, RotateApiKeyErrors, ThrowOnError>({ url: '/api/api-keys/{apiKeyId}/rotate', ...options });

/**
 * List audit events with optional filters and pagination
 */
export const listAuditEvents = <ThrowOnError extends boolean = false>(options?: Options<ListAuditEventsData, ThrowOnError>) => (options?.client ?? client).get<ListAuditEventsResponses, ListAuditEventsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/audit',
    ...options
});

/**
 * Get a single audit event by ID
 */
export const getAuditEvent = <ThrowOnError extends boolean = false>(options: Options<GetAuditEventData, ThrowOnError>) => (options.client ?? client).get<GetAuditEventResponses, GetAuditEventErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/audit/{eventId}',
    ...options
});

export const refresh = <ThrowOnError extends boolean = false>(options: Options<RefreshData, ThrowOnError>) => (options.client ?? client).post<RefreshResponses, RefreshErrors, ThrowOnError>({
    url: '/api/auth/browser-token/refresh',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const switchClient = <ThrowOnError extends boolean = false>(options: Options<SwitchClientData, ThrowOnError>) => (options.client ?? client).post<SwitchClientResponses, SwitchClientErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/auth/browser-token/switch-client',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const logout = <ThrowOnError extends boolean = false>(options?: Options<LogoutData, ThrowOnError>) => (options?.client ?? client).post<LogoutResponses, LogoutErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/auth/logout',
    ...options
});

export const status = <ThrowOnError extends boolean = false>(options?: Options<StatusData, ThrowOnError>) => (options?.client ?? client).get<StatusResponses, StatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/auth/status',
    ...options
});

/**
 * Confirm email change with verification code
 *
 * Completes the email change using the code that arrived via the frontend
 * confirm-page link in the confirmation email; the frontend calls this
 * endpoint with the user's current session, which must be the code owner.
 */
export const changeEmailConfirm = <ThrowOnError extends boolean = false>(options: Options<ChangeEmailConfirmData, ThrowOnError>) => (options.client ?? client).get<ChangeEmailConfirmResponses, ChangeEmailConfirmErrors, ThrowOnError>({ url: '/api/auth/{realmId}/change_email/confirm/{changeCode}', ...options });

/**
 * Request to change the email address for the authenticated user
 *
 * Sends a confirmation link to the new email address. The link points to the
 * first-party frontend confirm page, which the user must open in their
 * logged-in browser so the frontend can call the confirm endpoint with the
 * current session. Returns 400 when the realm has no usable email channel.
 */
export const changeEmailRequest = <ThrowOnError extends boolean = false>(options: Options<ChangeEmailRequestData, ThrowOnError>) => (options.client ?? client).post<ChangeEmailRequestResponses, ChangeEmailRequestErrors, ThrowOnError>({
    url: '/api/auth/{realmId}/change_email/request',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Public OTP-login enablement flag for a Realm.
 *
 * Reads the `email_otp` / `settings` config row. Returns `{ enabled: false }`
 * when the config is absent or malformed (opt-in per Realm).
 */
export const status2 = <ThrowOnError extends boolean = false>(options: Options<Status2Data, ThrowOnError>) => (options.client ?? client).get<Status2Responses, Status2Errors, ThrowOnError>({ url: '/api/auth/{realmId}/email-otp/status', ...options });

/**
 * Public LDAP enablement flag for a Realm (login-page entry visibility).
 * Fail-closed: absent/malformed/disabled/insecure-channel config → false.
 */
export const ldapStatus = <ThrowOnError extends boolean = false>(options: Options<LdapStatusData, ThrowOnError>) => (options.client ?? client).get<LdapStatusResponses, LdapStatusErrors, ThrowOnError>({ url: '/api/auth/{realmId}/ldap/status', ...options });

/**
 * Authenticate user with email/username and password
 *
 * Supports both email and username login. Returns a session token or requires TOTP verification
 * if two-factor authentication is enabled for the user.
 */
export const login = <ThrowOnError extends boolean = false>(options: Options<LoginData, ThrowOnError>) => (options.client ?? client).post<LoginResponses, LoginErrors, ThrowOnError>({
    url: '/api/auth/{realmId}/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Send an email OTP login code.
 *
 * Issues a one-time verification code for an existing active user, or — if the
 * Realm has OTP auto-register enabled — for an unregistered email after consent
 * is expressed. Partially enumeration-resistant: a 200 is returned for a known
 * but non-active user (no code sent). An explicit 409 is still returned for an
 * unregistered email when auto-register is off — the same registration-status
 * bit the register endpoint exposes by design (both paths sit behind Turnstile
 * and per-email/IP rate limits).
 */
export const send = <ThrowOnError extends boolean = false>(options: Options<SendData, ThrowOnError>) => (options.client ?? client).post<SendResponses, SendErrors, ThrowOnError>({
    url: '/api/auth/{realmId}/login/email-otp/send',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify an email OTP login code and issue a session.
 *
 * On a matching code: consumes it (one-time), then either logs the existing
 * user in (login-as-consent gate) or auto-registers a new account
 * (create-without-password → activate → register-as-consent) and issues a
 * Bearer token family via `RedisBrowserTokenService`. Returns `BrowserTokenResponse`.
 */
export const verify = <ThrowOnError extends boolean = false>(options: Options<VerifyData, ThrowOnError>) => (options.client ?? client).post<VerifyResponses, VerifyErrors, ThrowOnError>({
    url: '/api/auth/{realmId}/login/email-otp/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enterprise (LDAP) directory login.
 *
 * Authenticates the submitted username/password against the Realm's
 * configured directory (search-then-bind), matches or JIT-provisions the
 * Herald account, and then runs the full existing login pipeline
 * (2FA / consent / OAuth code / session issuance), auditing
 * `method="ldap"`.
 */
export const ldapLogin = <ThrowOnError extends boolean = false>(options: Options<LdapLoginData, ThrowOnError>) => (options.client ?? client).post<LdapLoginResponses, LdapLoginErrors, ThrowOnError>({
    url: '/api/auth/{realmId}/login/ldap',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const handlePasskey2FaOptions = <ThrowOnError extends boolean = false>(options: Options<HandlePasskey2FaOptionsData, ThrowOnError>) => (options.client ?? client).post<HandlePasskey2FaOptionsResponses, HandlePasskey2FaOptionsErrors, ThrowOnError>({
    url: '/api/auth/{realmId}/login/passkey/2fa/options',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const handlePasskey2FaVerify = <ThrowOnError extends boolean = false>(options: Options<HandlePasskey2FaVerifyData, ThrowOnError>) => (options.client ?? client).post<HandlePasskey2FaVerifyResponses, HandlePasskey2FaVerifyErrors, ThrowOnError>({
    url: '/api/auth/{realmId}/login/passkey/2fa/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const handlePasskeyOptions = <ThrowOnError extends boolean = false>(options: Options<HandlePasskeyOptionsData, ThrowOnError>) => (options.client ?? client).post<HandlePasskeyOptionsResponses, HandlePasskeyOptionsErrors, ThrowOnError>({
    url: '/api/auth/{realmId}/login/passkey/options',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const handlePasskeyVerify = <ThrowOnError extends boolean = false>(options: Options<HandlePasskeyVerifyData, ThrowOnError>) => (options.client ?? client).post<HandlePasskeyVerifyResponses, HandlePasskeyVerifyErrors, ThrowOnError>({
    url: '/api/auth/{realmId}/login/passkey/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Verify TOTP code for two-factor authentication
 *
 * Completes the login process for users with TOTP enabled. Accepts either a TOTP code
 * from an authenticator app or a backup code. Creates a permanent session on success.
 */
export const handleVerifyTotp = <ThrowOnError extends boolean = false>(options: Options<HandleVerifyTotpData, ThrowOnError>) => (options.client ?? client).post<HandleVerifyTotpResponses, HandleVerifyTotpErrors, ThrowOnError>({
    url: '/api/auth/{realmId}/login/verify-totp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Public passkey enablement flag for a Realm.
 *
 * Reads the `passkey` / `settings` config row and returns `{ enabled }`. The
 * login page uses this to decide whether to render the passkey entry before
 * any passkey endpoint is called, rather than discovering disablement via a
 * 404 from `POST /login/passkey/options`. Anonymous (no authentication).
 */
export const status3 = <ThrowOnError extends boolean = false>(options: Options<Status3Data, ThrowOnError>) => (options.client ?? client).get<Status3Responses, Status3Errors, ThrowOnError>({ url: '/api/auth/{realmId}/passkey/status', ...options });

/**
 * Register new user account
 *
 * Creates a new user account with email and optional username. If email verification is required
 * for realm, account will be created in a pending state and a verification email will be sent.
 */
export const register = <ThrowOnError extends boolean = false>(options: Options<RegisterData, ThrowOnError>) => (options.client ?? client).post<RegisterResponses, RegisterErrors, ThrowOnError>({
    url: '/api/auth/{realmId}/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get registration configuration status for a realm
 *
 * Returns whether user registration is enabled for the specified realm.
 */
export const getRegistrationStatus = <ThrowOnError extends boolean = false>(options: Options<GetRegistrationStatusData, ThrowOnError>) => (options.client ?? client).post<GetRegistrationStatusResponses, GetRegistrationStatusErrors, ThrowOnError>({ url: '/api/auth/{realmId}/registration/status', ...options });

/**
 * Confirm password reset with verification code
 *
 * Completes password reset process using verification code sent to user's email.
 */
export const resetPasswordConfirm = <ThrowOnError extends boolean = false>(options: Options<ResetPasswordConfirmData, ThrowOnError>) => (options.client ?? client).post<unknown, ResetPasswordConfirmErrors, ThrowOnError>({
    url: '/api/auth/{realmId}/reset_password/confirm/{resetCode}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Request password reset
 *
 * Initiates a password reset process by sending a verification code to user's email address.
 * Always returns success to prevent email enumeration.
 */
export const resetPasswordRequest = <ThrowOnError extends boolean = false>(options: Options<ResetPasswordRequestData, ThrowOnError>) => (options.client ?? client).post<ResetPasswordRequestResponses, ResetPasswordRequestErrors, ThrowOnError>({
    url: '/api/auth/{realmId}/reset_password/request',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Provision a new realm from an unauthenticated visitor and issue an
 * immediate first-party admin-console session for the new realm admin.
 *
 * Only the admin realm hosts this entry; any other `realmId` is rejected.
 * Pre-flight defenses run before any realm is created: the platform toggle,
 * human verification bound to the admin realm's `admin-web-console` Client
 * App, and a same-IP 24h quota.
 */
export const signup = <ThrowOnError extends boolean = false>(options: Options<SignupData, ThrowOnError>) => (options.client ?? client).post<SignupResponses, SignupErrors, ThrowOnError>({
    url: '/api/auth/{realmId}/signup',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Email the 6-digit verification code the signup flow will later consume.
 *
 * Only the admin realm hosts this entry; any other `realmId` is rejected.
 * No Turnstile here (same posture as the other code-only senders — the
 * per-IP + per-mailbox rate limits carry the anti-bombing defense), and the
 * platform toggle gates it fail-closed so the code sender can never outlive
 * the signup entry it serves.
 */
export const sendEmailCode = <ThrowOnError extends boolean = false>(options: Options<SendEmailCodeData, ThrowOnError>) => (options.client ?? client).post<SendEmailCodeResponses, SendEmailCodeErrors, ThrowOnError>({
    url: '/api/auth/{realmId}/signup/email_code',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Public visibility of the self-service entry. Fail-closed: a missing toggle
 * row resolves to `enabled: false`.
 */
export const getSignupStatus = <ThrowOnError extends boolean = false>(options: Options<GetSignupStatusData, ThrowOnError>) => (options.client ?? client).get<GetSignupStatusResponses, GetSignupStatusErrors, ThrowOnError>({ url: '/api/auth/{realmId}/signup/status', ...options });

/**
 * Get Turnstile configuration status for a Client App
 *
 * Returns whether Turnstile verification is enabled for the specified Client
 * App and the site key to render the widget. Turnstile is fully delegated to
 * the Client App (D-PROTECT-01); the legacy realm_config source is no longer
 * read. A missing or disabled Client App is rejected with 401, matching the
 * other anonymous Client-App-bound endpoints. Pass `clientId` as a query
 * parameter.
 */
export const getTurnstileStatus = <ThrowOnError extends boolean = false>(options: Options<GetTurnstileStatusData, ThrowOnError>) => (options.client ?? client).get<GetTurnstileStatusResponses, GetTurnstileStatusErrors, ThrowOnError>({ url: '/api/auth/{realmId}/turnstile/status', ...options });

/**
 * Confirm email verification with code
 *
 * Completes email verification process using verification code sent to user's email.
 * Activates user account upon successful verification.
 */
export const verifyEmailConfirm = <ThrowOnError extends boolean = false>(options: Options<VerifyEmailConfirmData, ThrowOnError>) => (options.client ?? client).get<unknown, VerifyEmailConfirmErrors, ThrowOnError>({ url: '/api/auth/{realmId}/verify_email/confirm/{emailVerificationCode}', ...options });

/**
 * Trigger email verification
 *
 * Sends a verification email to specified email address with a confirmation link.
 * Used to initiate email verification for pending accounts.
 */
export const verifyEmailTrigger = <ThrowOnError extends boolean = false>(options: Options<VerifyEmailTriggerData, ThrowOnError>) => (options.client ?? client).post<VerifyEmailTriggerResponses, VerifyEmailTriggerErrors, ThrowOnError>({
    url: '/api/auth/{realmId}/verify_email/trigger',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List purchasable price-level options for a client app.
 *
 * Returns a FLAT list of enabled price-granularity mappings (recurring +
 * one_time) for the purchase page; the frontend groups by
 * `external_product_id` / billing period. Replaces the purchase page's
 * dependency on `list_one_time_mappings` (which only covered one_time).
 */
export const listPurchaseOptions = <ThrowOnError extends boolean = false>(options: Options<ListPurchaseOptionsData, ThrowOnError>) => (options.client ?? client).get<ListPurchaseOptionsResponses, ListPurchaseOptionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/client/{clientAppId}/purchase-options',
    ...options
});

/**
 * Get subscription for a client app
 */
export const getSubscriptionForClientApp = <ThrowOnError extends boolean = false>(options: Options<GetSubscriptionForClientAppData, ThrowOnError>) => (options.client ?? client).get<GetSubscriptionForClientAppResponses, GetSubscriptionForClientAppErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/client/{clientAppId}/subscription',
    ...options
});

/**
 * Cancel the caller's own subscription for a client app.
 *
 * Unlike the previous admin-only flip, this handler is a **user self-service**
 * endpoint mounted on the browser-token router. It calls the **payment provider
 * cancel API** (Stripe/Creem) and does **NOT** touch the local subscription
 * row — local status is updated exclusively by the subsequent provider webhook
 * (`customer.subscription.deleted` / `subscription.canceled`). If the provider
 * call fails the error is surfaced to the caller and the local state is left
 * untouched.
 *
 * Apple / Google in-app purchases cannot be canceled via a developer API
 * (only via the App Store / Play Store by the user); this endpoint rejects
 * them with 400.
 */
export const cancelSubscriptionForClientApp = <ThrowOnError extends boolean = false>(options: Options<CancelSubscriptionForClientAppData, ThrowOnError>) => (options.client ?? client).post<CancelSubscriptionForClientAppResponses, CancelSubscriptionForClientAppErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/client/{clientAppId}/subscription/cancel',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List all Credit Buckets for a realm.
 */
export const listCreditBucketsHandler = <ThrowOnError extends boolean = false>(options?: Options<ListCreditBucketsHandlerData, ThrowOnError>) => (options?.client ?? client).get<ListCreditBucketsHandlerResponses, ListCreditBucketsHandlerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/credit-buckets',
    ...options
});

/**
 * Create a Credit Bucket.
 */
export const createCreditBucketHandler = <ThrowOnError extends boolean = false>(options: Options<CreateCreditBucketHandlerData, ThrowOnError>) => (options.client ?? client).post<CreateCreditBucketHandlerResponses, CreateCreditBucketHandlerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/credit-buckets',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the bucket overview matrix.
 *
 * Returns `{ rows: OverviewRow[], grandTotal: ByCreditType }` — `grandTotal`
 * is a SEPARATE top-level field, not appended to rows.
 */
export const getBucketOverviewHandler = <ThrowOnError extends boolean = false>(options?: Options<GetBucketOverviewHandlerData, ThrowOnError>) => (options?.client ?? client).get<GetBucketOverviewHandlerResponses, GetBucketOverviewHandlerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/credit-buckets/overview',
    ...options
});

/**
 * Delete a Credit Bucket (DELETE).
 *
 * 204 on success; 409 `bucket_in_use` with `{ code, activeSubscriptions,
 * holdersWithBalance, ruleReferences, historyReferences }` when in-flight
 * subscriptions, residual balances, rule references or history exist.
 */
export const deleteCreditBucketHandler = <ThrowOnError extends boolean = false>(options: Options<DeleteCreditBucketHandlerData, ThrowOnError>) => (options.client ?? client).delete<DeleteCreditBucketHandlerResponses, DeleteCreditBucketHandlerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/credit-buckets/{bucketId}',
    ...options
});

/**
 * Get a single Credit Bucket with coverage set and attached mappings.
 */
export const getCreditBucketHandler = <ThrowOnError extends boolean = false>(options: Options<GetCreditBucketHandlerData, ThrowOnError>) => (options.client ?? client).get<GetCreditBucketHandlerResponses, GetCreditBucketHandlerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/credit-buckets/{bucketId}',
    ...options
});

/**
 * Update a Credit Bucket (PUT). Coverage set is fully replaced.
 */
export const updateCreditBucketHandler = <ThrowOnError extends boolean = false>(options: Options<UpdateCreditBucketHandlerData, ThrowOnError>) => (options.client ?? client).put<UpdateCreditBucketHandlerResponses, UpdateCreditBucketHandlerErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/credit-buckets/{bucketId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List entitlement mappings for a realm
 */
export const listEntitlementMappings = <ThrowOnError extends boolean = false>(options?: Options<ListEntitlementMappingsData, ThrowOnError>) => (options?.client ?? client).get<ListEntitlementMappingsResponses, ListEntitlementMappingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/entitlement-mappings',
    ...options
});

/**
 * Generic over provider (IAP, Stripe, Creem). Required permission:
 * `billing.manage`; distribution-rule fields additionally require `points.manage`
 * (mirrors the batch update permission model). A duplicate
 * `(realm, provider, product, price)` row violates
 * `uq_pem_realm_provider_product_price` and surfaces as HTTP 409.
 */
export const createEntitlementMapping = <ThrowOnError extends boolean = false>(options: Options<CreateEntitlementMappingData, ThrowOnError>) => (options.client ?? client).post<CreateEntitlementMappingResponses, CreateEntitlementMappingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/entitlement-mappings',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Batch-save all price mappings for a product.
 *
 * Validation/permission order:
 * 1. `billing.manage` (realm boundary + business permission).
 * 2. If any update row carries a credit-strategy field → `points.manage`.
 * 3. Credit-strategy field validation.
 *
 * Then the repository performs a single-transaction upsert of all the
 * product's price rows: any row transitioning enabled true→false while protected by an active
 * subscription rolls back the WHOLE transaction (409 with
 * `{ activeSubscriptions }`). Cross-realm/product `mapping_id` tampering surfaces as 400.
 */
export const batchUpdateEntitlementMappings = <ThrowOnError extends boolean = false>(options: Options<BatchUpdateEntitlementMappingsData, ThrowOnError>) => (options.client ?? client).put<BatchUpdateEntitlementMappingsResponses, BatchUpdateEntitlementMappingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/entitlement-mappings/batch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Sync provider products into entitlement mappings
 */
export const syncProviderProducts = <ThrowOnError extends boolean = false>(options: Options<SyncProviderProductsData, ThrowOnError>) => (options.client ?? client).post<SyncProviderProductsResponses, SyncProviderProductsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/entitlement-mappings/sync',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a single entitlement mapping
 */
export const getEntitlementMapping = <ThrowOnError extends boolean = false>(options: Options<GetEntitlementMappingData, ThrowOnError>) => (options.client ?? client).get<GetEntitlementMappingResponses, GetEntitlementMappingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/entitlement-mappings/{mappingId}',
    ...options
});

/**
 * Update an entitlement mapping
 */
export const updateEntitlementMapping = <ThrowOnError extends boolean = false>(options: Options<UpdateEntitlementMappingData, ThrowOnError>) => (options.client ?? client).patch<UpdateEntitlementMappingResponses, UpdateEntitlementMappingErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/entitlement-mappings/{mappingId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getFeatureAvailability = <ThrowOnError extends boolean = false>(options?: Options<GetFeatureAvailabilityData, ThrowOnError>) => (options?.client ?? client).get<GetFeatureAvailabilityResponses, GetFeatureAvailabilityErrors, ThrowOnError>({ url: '/api/bill/feature-availability', ...options });

/**
 * Admin read-only attribution anomaly discovery.
 *
 * Returns two anomaly classes:
 * - `unattributed_invoices`: externally-synced invoices that lack both
 * `subscription_id` and `payment_attempt_id` (reuses `list_admin` with
 * `attribution=Missing`, capped at the first 100 rows).
 * - `payments_without_invoice`: succeeded renewal / one-time payment attempts
 * inside a 90-day window with no invoice linked via
 * `invoice.payment_attempt_id` (anti-join read; no writes).
 *
 * Permission reuses `require_billing_permission(..., "view")` — same model as
 * `GET /invoices`. Realm isolation is enforced both by the repository
 * (`realm_id` filter) and the shared middleware.
 */
export const listAttributionAnomalies = <ThrowOnError extends boolean = false>(options?: Options<ListAttributionAnomaliesData, ThrowOnError>) => (options?.client ?? client).get<ListAttributionAnomaliesResponses, ListAttributionAnomaliesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/invoice-attribution/anomalies',
    ...options
});

export const getSellerConfig = <ThrowOnError extends boolean = false>(options?: Options<GetSellerConfigData, ThrowOnError>) => (options?.client ?? client).get<GetSellerConfigResponses, GetSellerConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/invoice-seller-config',
    ...options
});

export const upsertSellerConfig = <ThrowOnError extends boolean = false>(options: Options<UpsertSellerConfigData, ThrowOnError>) => (options.client ?? client).put<UpsertSellerConfigResponses, UpsertSellerConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/invoice-seller-config',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listInvoices = <ThrowOnError extends boolean = false>(options?: Options<ListInvoicesData, ThrowOnError>) => (options?.client ?? client).get<ListInvoicesResponses, ListInvoicesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/invoices',
    ...options
});

export const createInvoice = <ThrowOnError extends boolean = false>(options: Options<CreateInvoiceData, ThrowOnError>) => (options.client ?? client).post<CreateInvoiceResponses, CreateInvoiceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/invoices',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getInvoice = <ThrowOnError extends boolean = false>(options: Options<GetInvoiceData, ThrowOnError>) => (options.client ?? client).get<GetInvoiceResponses, GetInvoiceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/invoices/{invoiceId}',
    ...options
});

export const updateInvoice = <ThrowOnError extends boolean = false>(options: Options<UpdateInvoiceData, ThrowOnError>) => (options.client ?? client).patch<UpdateInvoiceResponses, UpdateInvoiceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/invoices/{invoiceId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const createCreditNote = <ThrowOnError extends boolean = false>(options: Options<CreateCreditNoteData, ThrowOnError>) => (options.client ?? client).post<CreateCreditNoteResponses, CreateCreditNoteErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/invoices/{invoiceId}/credit-notes',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const issueInvoice = <ThrowOnError extends boolean = false>(options: Options<IssueInvoiceData, ThrowOnError>) => (options.client ?? client).post<IssueInvoiceResponses, IssueInvoiceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/invoices/{invoiceId}/issue',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const markPaid = <ThrowOnError extends boolean = false>(options: Options<MarkPaidData, ThrowOnError>) => (options.client ?? client).post<MarkPaidResponses, MarkPaidErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/invoices/{invoiceId}/mark-paid',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const downloadInvoicePdf = <ThrowOnError extends boolean = false>(options: Options<DownloadInvoicePdfData, ThrowOnError>) => (options.client ?? client).get<DownloadInvoicePdfResponses, DownloadInvoicePdfErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/invoices/{invoiceId}/pdf',
    ...options
});

export const voidInvoice = <ThrowOnError extends boolean = false>(options: Options<VoidInvoiceData, ThrowOnError>) => (options.client ?? client).post<VoidInvoiceResponses, VoidInvoiceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/invoices/{invoiceId}/void',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List current user's subscription history with filtering and pagination
 */
export const listMySubscriptionHistory = <ThrowOnError extends boolean = false>(options?: Options<ListMySubscriptionHistoryData, ThrowOnError>) => (options?.client ?? client).get<ListMySubscriptionHistoryResponses, ListMySubscriptionHistoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/my/subscriptions/history',
    ...options
});

/**
 * Get current user's subscription history for a specific subscription
 */
export const getMySubscriptionHistory = <ThrowOnError extends boolean = false>(options: Options<GetMySubscriptionHistoryData, ThrowOnError>) => (options.client ?? client).get<GetMySubscriptionHistoryResponses, GetMySubscriptionHistoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/my/subscriptions/{subscriptionId}/history',
    ...options
});

/**
 * List enabled one-time entitlement mappings for a realm
 */
export const listOneTimeMappings = <ThrowOnError extends boolean = false>(options?: Options<ListOneTimeMappingsData, ThrowOnError>) => (options?.client ?? client).get<ListOneTimeMappingsResponses, ListOneTimeMappingsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/one-time-mappings',
    ...options
});

export const listPaymentProviders = <ThrowOnError extends boolean = false>(options?: Options<ListPaymentProvidersData, ThrowOnError>) => (options?.client ?? client).get<ListPaymentProvidersResponses, ListPaymentProvidersErrors, ThrowOnError>({ url: '/api/bill/providers', ...options });

export const getRealmPurchaseHistory = <ThrowOnError extends boolean = false>(options?: Options<GetRealmPurchaseHistoryData, ThrowOnError>) => (options?.client ?? client).get<GetRealmPurchaseHistoryResponses, GetRealmPurchaseHistoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/purchase/history',
    ...options
});

export const submitIapReceipt = <ThrowOnError extends boolean = false>(options: Options<SubmitIapReceiptData, ThrowOnError>) => (options.client ?? client).post<SubmitIapReceiptResponses, SubmitIapReceiptErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/purchase/iap/receipt',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const createPaymentAttempt = <ThrowOnError extends boolean = false>(options: Options<CreatePaymentAttemptData, ThrowOnError>) => (options.client ?? client).post<CreatePaymentAttemptResponses, CreatePaymentAttemptErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/purchase/payment-attempts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getPaymentAttemptStatus = <ThrowOnError extends boolean = false>(options: Options<GetPaymentAttemptStatusData, ThrowOnError>) => (options.client ?? client).get<GetPaymentAttemptStatusResponses, GetPaymentAttemptStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/purchase/payment-attempts/{attemptId}',
    ...options
});

export const cancelPaymentAttempt = <ThrowOnError extends boolean = false>(options: Options<CancelPaymentAttemptData, ThrowOnError>) => (options.client ?? client).post<CancelPaymentAttemptResponses, CancelPaymentAttemptErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/purchase/payment-attempts/{attemptId}/cancel',
    ...options
});

/**
 * Payment statistics for the admin statistics page.
 *
 * Counts only finalized attempts (Succeeded/Failed) attributed to their
 * initiation day (`created_at`). Requires the `billing.view` permission.
 */
export const getPaymentStats = <ThrowOnError extends boolean = false>(options?: Options<GetPaymentStatsData, ThrowOnError>) => (options?.client ?? client).get<GetPaymentStatsResponses, GetPaymentStatsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/stats/payments',
    ...options
});

/**
 * List subscriptions for a realm
 */
export const listSubscriptions = <ThrowOnError extends boolean = false>(options?: Options<ListSubscriptionsData, ThrowOnError>) => (options?.client ?? client).get<ListSubscriptionsResponses, ListSubscriptionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/subscriptions',
    ...options
});

/**
 * List subscription history with filtering and pagination
 */
export const listSubscriptionHistory = <ThrowOnError extends boolean = false>(options?: Options<ListSubscriptionHistoryData, ThrowOnError>) => (options?.client ?? client).get<ListSubscriptionHistoryResponses, ListSubscriptionHistoryErrors, ThrowOnError>({ url: '/api/bill/subscriptions/history', ...options });

/**
 * Get a specific subscription
 */
export const getSubscription = <ThrowOnError extends boolean = false>(options: Options<GetSubscriptionData, ThrowOnError>) => (options.client ?? client).get<GetSubscriptionResponses, GetSubscriptionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/bill/subscriptions/{subscriptionId}',
    ...options
});

/**
 * Get subscription history for a specific subscription
 */
export const getSubscriptionHistory = <ThrowOnError extends boolean = false>(options: Options<GetSubscriptionHistoryData, ThrowOnError>) => (options.client ?? client).get<GetSubscriptionHistoryResponses, GetSubscriptionHistoryErrors, ThrowOnError>({ url: '/api/bill/subscriptions/{subscriptionId}/history', ...options });

/**
 * List client applications
 *
 * List all OAuth client applications configured for the specified realm with pagination. Requires `clients.view` permission.
 */
export const listClientApps = <ThrowOnError extends boolean = false>(options?: Options<ListClientAppsData, ThrowOnError>) => (options?.client ?? client).get<ListClientAppsResponses, ListClientAppsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/client',
    ...options
});

/**
 * Create a new client app
 *
 * Creates a new OAuth client application with the specified configuration.
 */
export const createClientApp = <ThrowOnError extends boolean = false>(options: Options<CreateClientAppData, ThrowOnError>) => (options.client ?? client).post<CreateClientAppResponses, CreateClientAppErrors, ThrowOnError>({
    url: '/api/client',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a client app
 *
 * Deletes an OAuth client application and its associated roles.
 * Built-in client apps (admin console, user account center, the realm's
 * built-in API Key client app, and the built-in MCP client) cannot be
 * deleted — disabling is the supported off-switch for the MCP client.
 */
export const deleteClientApp = <ThrowOnError extends boolean = false>(options: Options<DeleteClientAppData, ThrowOnError>) => (options.client ?? client).delete<DeleteClientAppResponses, DeleteClientAppErrors, ThrowOnError>({ url: '/api/client/{clientAppId}', ...options });

/**
 * Get a specific client app by ID
 *
 * Retrieves the details of a specific OAuth client application.
 */
export const getClientApp = <ThrowOnError extends boolean = false>(options: Options<GetClientAppData, ThrowOnError>) => (options.client ?? client).get<GetClientAppResponses, GetClientAppErrors, ThrowOnError>({ url: '/api/client/{clientAppId}', ...options });

/**
 * Update a client app configuration
 *
 * Updates the configuration of an existing OAuth client application.
 * Optionally regenerate the client secret.
 */
export const updateClientApp = <ThrowOnError extends boolean = false>(options: Options<UpdateClientAppData, ThrowOnError>) => (options.client ?? client).put<UpdateClientAppResponses, UpdateClientAppErrors, ThrowOnError>({
    url: '/api/client/{clientAppId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all configs for a given realm
 */
export const listRealmConfigs = <ThrowOnError extends boolean = false>(options?: Options<ListRealmConfigsData, ThrowOnError>) => (options?.client ?? client).get<ListRealmConfigsResponses, ListRealmConfigsErrors, ThrowOnError>({ url: '/api/configs', ...options });

/**
 * Create or update a config (upsert)
 */
export const upsertRealmConfig = <ThrowOnError extends boolean = false>(options: Options<UpsertRealmConfigData, ThrowOnError>) => (options.client ?? client).put<UpsertRealmConfigResponses, UpsertRealmConfigErrors, ThrowOnError>({
    url: '/api/configs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Batch create or update configs
 */
export const batchUpsertRealmConfigs = <ThrowOnError extends boolean = false>(options: Options<BatchUpsertRealmConfigsData, ThrowOnError>) => (options.client ?? client).post<BatchUpsertRealmConfigsResponses, BatchUpsertRealmConfigsErrors, ThrowOnError>({
    url: '/api/configs/batch',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get email configuration status for a realm
 */
export const emailStatus = <ThrowOnError extends boolean = false>(options?: Options<EmailStatusData, ThrowOnError>) => (options?.client ?? client).get<EmailStatusResponses, EmailStatusErrors, ThrowOnError>({ url: '/api/configs/email/status', ...options });

/**
 * Send a test email for a realm
 */
export const emailTest = <ThrowOnError extends boolean = false>(options: Options<EmailTestData, ThrowOnError>) => (options.client ?? client).post<EmailTestResponses, EmailTestErrors, ThrowOnError>({
    url: '/api/configs/email/test',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get all configs of a given type
 */
export const listRealmConfigsByType = <ThrowOnError extends boolean = false>(options: Options<ListRealmConfigsByTypeData, ThrowOnError>) => (options.client ?? client).get<ListRealmConfigsByTypeResponses, ListRealmConfigsByTypeErrors, ThrowOnError>({ url: '/api/configs/{configType}', ...options });

/**
 * Delete a config
 */
export const deleteRealmConfig = <ThrowOnError extends boolean = false>(options: Options<DeleteRealmConfigData, ThrowOnError>) => (options.client ?? client).delete<DeleteRealmConfigResponses, DeleteRealmConfigErrors, ThrowOnError>({ url: '/api/configs/{configType}/{configKey}', ...options });

/**
 * Get a single config
 */
export const getRealmConfig = <ThrowOnError extends boolean = false>(options: Options<GetRealmConfigData, ThrowOnError>) => (options.client ?? client).get<GetRealmConfigResponses, GetRealmConfigErrors, ThrowOnError>({ url: '/api/configs/{configType}/{configKey}', ...options });

/**
 * Get dashboard statistics for a realm
 */
export const getDashboardStats = <ThrowOnError extends boolean = false>(options?: Options<GetDashboardStatsData, ThrowOnError>) => (options?.client ?? client).get<GetDashboardStatsResponses, GetDashboardStatsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/dashboard/stats',
    ...options
});

export const deviceAuthorize = <ThrowOnError extends boolean = false>(options: Options<DeviceAuthorizeData, ThrowOnError>) => (options.client ?? client).post<DeviceAuthorizeResponses, DeviceAuthorizeErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    url: '/api/device/{realmId}/authorize',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

export const deviceConfirm = <ThrowOnError extends boolean = false>(options: Options<DeviceConfirmData, ThrowOnError>) => (options.client ?? client).post<DeviceConfirmResponses, DeviceConfirmErrors, ThrowOnError>({
    url: '/api/device/{realmId}/confirm',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const deviceToken = <ThrowOnError extends boolean = false>(options: Options<DeviceTokenData, ThrowOnError>) => (options.client ?? client).post<DeviceTokenResponses, DeviceTokenErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    url: '/api/device/{realmId}/token',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

export const deviceVerify = <ThrowOnError extends boolean = false>(options: Options<DeviceVerifyData, ThrowOnError>) => (options.client ?? client).post<DeviceVerifyResponses, DeviceVerifyErrors, ThrowOnError>({
    url: '/api/device/{realmId}/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get subscription for a client app
 *
 * Returns subscription details for the specified client app.
 *
 * # Authentication
 * Requires valid API Key via X-API-Key header
 *
 * # Realm Isolation
 * The API key must belong to the same realm as the client app.
 * Cross-realm requests will return 403 Forbidden.
 *
 * # Example
 * ```bash
 * curl -X GET \
 * https://api.example.com/api/ext/bill/realm123/client/client-app-123/subscription \
 * -H "X-API-Key: your-api-key"
 * ```
 */
export const getSubscription2 = <ThrowOnError extends boolean = false>(options: Options<GetSubscription2Data, ThrowOnError>) => (options.client ?? client).get<GetSubscription2Responses, GetSubscription2Errors, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/ext/bill/{realmId}/client/{clientAppId}/subscription',
    ...options
});

/**
 * Check user permissions
 *
 * This endpoint allows third-party applications to check if a user
 * has specific permissions using their browser access token.
 *
 * # Authentication
 * Requires valid API Key via X-API-Key header
 *
 * # Example
 * ```json
 * {
 * "accessToken": "user-access-token",
 * "rules": [
 * {"resource": "article", "action": "read"},
 * {"resource": "article", "action": "write"}
 * ]
 * }
 * ```
 */
export const checkPermission = <ThrowOnError extends boolean = false>(options: Options<CheckPermissionData, ThrowOnError>) => (options.client ?? client).post<CheckPermissionResponses, CheckPermissionErrors, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/ext/permission/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const getBalanceExt = <ThrowOnError extends boolean = false>(options: Options<GetBalanceExtData, ThrowOnError>) => (options.client ?? client).get<GetBalanceExtResponses, GetBalanceExtErrors, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/ext/points/{realmId}/balance',
    ...options
});

/**
 * Consume points from user account
 *
 * Consumes points from a user's account for paid operations.
 * Returns transaction details including the new balance.
 *
 * # Authentication
 * Requires valid API Key via X-API-Key header
 *
 * # Realm Isolation
 * The API key must belong to the same realm as the requested realm.
 * Cross-realm requests will return 403 Forbidden.
 *
 * # Example
 * ```bash
 * curl -X POST \
 * https://api.example.com/api/ext/points/realm123/consume \
 * -H "X-API-Key: your-api-key" \
 * -H "Content-Type: application/json" \
 * -d '{
 * "userId": "user-123",
 * "clientAppId": "app-abc",
 * "amount": 100,
 * "description": "AI API call"
 * }'
 * ```
 */
export const consumePointsExt = <ThrowOnError extends boolean = false>(options: Options<ConsumePointsExtData, ThrowOnError>) => (options.client ?? client).post<ConsumePointsExtResponses, ConsumePointsExtErrors, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/ext/points/{realmId}/consume',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Grant points to a user account (SDK)
 *
 * Grants points to a user's account from a third-party application.
 * Returns transaction details including the new balance.
 *
 * # Authentication
 * Requires valid API Key via X-API-Key header
 *
 * # Realm Isolation
 * The API key must belong to the same realm as the requested realm.
 * Cross-realm requests will return 403 Forbidden.
 *
 * # Example
 * ```bash
 * curl -X POST \
 * https://api.example.com/api/ext/points/realm123/grant \
 * -H "X-API-Key: your-api-key" \
 * -H "Content-Type: application/json" \
 * -d '{
 * "userId": "user-123",
 * "amount": 100,
 * "reason": "Promotional grant"
 * }'
 * ```
 */
export const grantPointsExt = <ThrowOnError extends boolean = false>(options: Options<GrantPointsExtData, ThrowOnError>) => (options.client ?? client).post<GrantPointsExtResponses, GrantPointsExtErrors, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/ext/points/{realmId}/grant',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get transaction by external reference ID
 *
 * Returns details of a specific points transaction by `externalRefId`.
 */
export const getTransactionByExternalRefExt = <ThrowOnError extends boolean = false>(options: Options<GetTransactionByExternalRefExtData, ThrowOnError>) => (options.client ?? client).get<GetTransactionByExternalRefExtResponses, GetTransactionByExternalRefExtErrors, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/ext/points/{realmId}/transactions/by-external-ref/{externalRefId}',
    ...options
});

/**
 * Get transaction by ID
 *
 * Returns details of a specific points transaction.
 *
 * # Authentication
 * Requires valid API Key via X-API-Key header
 *
 * # Realm Isolation
 * The API key must belong to the same realm as the requested realm.
 * Cross-realm requests will return 403 Forbidden.
 *
 * # Example
 * ```bash
 * curl -X GET \
 * https://api.example.com/api/ext/points/realm123/transactions/uuid \
 * -H "X-API-Key: your-api-key"
 * ```
 */
export const getTransactionExt = <ThrowOnError extends boolean = false>(options: Options<GetTransactionExtData, ThrowOnError>) => (options.client ?? client).get<GetTransactionExtResponses, GetTransactionExtErrors, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/ext/points/{realmId}/transactions/{transactionId}',
    ...options
});

/**
 * List realms
 *
 * Returns the realms visible to the caller. Principals in the `admin` realm
 * see all realms (platform-level enumeration); every other principal sees
 * only its own realm. Realm-level detail endpoints remain strictly
 * own-realm — this list is the only platform-wide view.
 *
 * # Authentication
 * Requires valid API Key via X-API-Key header
 *
 * # Authorization
 * The caller must have `realm:view` permission in their own realm.
 */
export const listRealms = <ThrowOnError extends boolean = false>(options?: Options<ListRealmsData, ThrowOnError>) => (options?.client ?? client).get<ListRealmsResponses, ListRealmsErrors, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/ext/realms',
    ...options
});

/**
 * Create a new realm
 *
 * Creates a new realm in the system. Only principals with `realm:manage` permission
 * in the admin realm may invoke this endpoint.
 *
 * # Authentication
 * Requires valid API Key via X-API-Key header
 *
 * # Authorization
 * The caller must have `realm:manage` permission in the `admin` realm.
 */
export const createRealm = <ThrowOnError extends boolean = false>(options: Options<CreateRealmData, ThrowOnError>) => (options.client ?? client).post<CreateRealmResponses, CreateRealmErrors, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/ext/realms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a single realm by ID
 *
 * Returns detailed information for the specified realm.
 *
 * # Authentication
 * Requires valid API Key via X-API-Key header
 *
 * # Authorization
 * The caller must have `realm:view` permission in the target realm.
 * Every principal may only view its own realm (no super-admin).
 */
export const getRealm = <ThrowOnError extends boolean = false>(options: Options<GetRealmData, ThrowOnError>) => (options.client ?? client).get<GetRealmResponses, GetRealmErrors, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/ext/realms/{realmId}',
    ...options
});

/**
 * List client apps in a realm
 *
 * Returns all client apps in the specified realm.
 *
 * # Authentication
 * Requires valid API Key via X-API-Key header
 *
 * # Authorization
 * The caller must have `clients:view` permission in the target realm.
 */
export const listClientApps2 = <ThrowOnError extends boolean = false>(options: Options<ListClientApps2Data, ThrowOnError>) => (options.client ?? client).get<ListClientApps2Responses, ListClientApps2Errors, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/ext/realms/{realmId}/client-apps',
    ...options
});

/**
 * Create a new client app in a realm
 *
 * Creates a client app in the specified realm. Only principals with `clients:manage` permission
 * in the target realm may invoke this endpoint.
 *
 * # Authentication
 * Requires valid API Key via X-API-Key header
 *
 * # Authorization
 * The caller must have `clients:manage` permission in the target realm.
 */
export const createClientApp2 = <ThrowOnError extends boolean = false>(options: Options<CreateClientApp2Data, ThrowOnError>) => (options.client ?? client).post<CreateClientApp2Responses, CreateClientApp2Errors, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/ext/realms/{realmId}/client-apps',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a single client app by ID within a realm
 *
 * Returns detailed information for the specified client app.
 *
 * # Authentication
 * Requires valid API Key via X-API-Key header
 *
 * # Authorization
 * The caller must have `clients:view` permission in the target realm.
 */
export const getClientApp2 = <ThrowOnError extends boolean = false>(options: Options<GetClientApp2Data, ThrowOnError>) => (options.client ?? client).get<GetClientApp2Responses, GetClientApp2Errors, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/ext/realms/{realmId}/client-apps/{clientAppId}',
    ...options
});

/**
 * List users in a realm
 *
 * Returns a paginated list of users in the specified realm.
 * Default page_size is 20, maximum is 100.
 *
 * # Authentication
 * Requires valid API Key via X-API-Key header
 *
 * # Authorization
 * The caller must have `users:view` permission in the target realm.
 */
export const listUsers = <ThrowOnError extends boolean = false>(options: Options<ListUsersData, ThrowOnError>) => (options.client ?? client).get<ListUsersResponses, ListUsersErrors, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/ext/realms/{realmId}/users',
    ...options
});

/**
 * Create a new user in a realm
 *
 * Creates a user in the specified realm. Only principals with `users:create` permission
 * in the target realm may invoke this endpoint.
 *
 * # Authentication
 * Requires valid API Key via X-API-Key header
 *
 * # Authorization
 * The caller must have `users:create` permission in the target realm.
 */
export const createUser = <ThrowOnError extends boolean = false>(options: Options<CreateUserData, ThrowOnError>) => (options.client ?? client).post<CreateUserResponses, CreateUserErrors, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/ext/realms/{realmId}/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get a single user by ID within a realm
 *
 * Returns detailed information for the specified user.
 *
 * # Authentication
 * Requires valid API Key via X-API-Key header
 *
 * # Authorization
 * The caller must have `users:view` permission in the target realm.
 */
export const getUser = <ThrowOnError extends boolean = false>(options: Options<GetUserData, ThrowOnError>) => (options.client ?? client).get<GetUserResponses, GetUserErrors, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/ext/realms/{realmId}/users/{userId}',
    ...options
});

/**
 * Get subscription status for a client app
 *
 * Returns subscription information for the specified client app.
 *
 * # Authentication
 * Requires valid API Key via X-API-Key header
 *
 * # Realm Isolation
 * The API key must belong to the same realm as the client app.
 * Cross-realm requests will return 403 Forbidden.
 *
 * # Example
 * ```bash
 * curl -X GET \
 * https://api.example.com/api/ext/subscription/client-app-123 \
 * -H "X-API-Key: your-api-key"
 * ```
 */
export const getSubscription3 = <ThrowOnError extends boolean = false>(options: Options<GetSubscription3Data, ThrowOnError>) => (options.client ?? client).get<GetSubscription3Responses, GetSubscription3Errors, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/ext/subscription/{clientAppId}',
    ...options
});

/**
 * Get the currency set supported by a purchasable entitlement
 *
 * Returns the deduplicated currencies covered by the entitlement's enabled
 * Stripe mapping rows (subscription-type and one-time-type rows both count).
 * Creem/IAP rows are excluded: their pricing is provider/store-side and
 * carries no per-currency price rows.
 *
 * # Authentication
 * Requires valid API Key via X-API-Key header
 *
 * # Realm Isolation
 * The API key must belong to the same realm as the requested realm.
 */
export const getEntitlementCurrencies = <ThrowOnError extends boolean = false>(options: Options<GetEntitlementCurrenciesData, ThrowOnError>) => (options.client ?? client).get<GetEntitlementCurrenciesResponses, GetEntitlementCurrenciesErrors, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/ext/{realmId}/entitlements/{entitlementKey}/currencies',
    ...options
});

/**
 * Resolve an entitlement's default price row by currency
 *
 * Filters the entitlement's enabled Stripe mapping rows by the requested
 * currency (plus optional billing type/period filters) and returns the unique
 * match. Fail-loud by design: 404 when no row matches the currency (no
 * secondary-currency fallback), 409 when multiple rows remain and the caller
 * must narrow by billing type/period.
 *
 * # Authentication
 * Requires valid API Key via X-API-Key header
 *
 * # Realm Isolation
 * The API key must belong to the same realm as the requested realm.
 */
export const resolveDefaultPrice = <ThrowOnError extends boolean = false>(options: Options<ResolveDefaultPriceData, ThrowOnError>) => (options.client ?? client).get<ResolveDefaultPriceResponses, ResolveDefaultPriceErrors, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/ext/{realmId}/entitlements/{entitlementKey}/default-price',
    ...options
});

/**
 * Get purchasable one-time entitlement mappings
 *
 * Returns enabled one-time entitlement mappings that have provider product info configured.
 * Used by frontend/SDK to display purchasable products.
 *
 * # Authentication
 * Requires valid API Key via X-API-Key header
 *
 * # Realm Isolation
 * The API key must belong to the same realm as the requested realm.
 * Cross-realm requests will return 403 Forbidden.
 */
export const getOneTimeMappings = <ThrowOnError extends boolean = false>(options: Options<GetOneTimeMappingsData, ThrowOnError>) => (options.client ?? client).get<GetOneTimeMappingsResponses, GetOneTimeMappingsErrors, ThrowOnError>({
    security: [{ name: 'X-API-Key', type: 'apiKey' }],
    url: '/api/ext/{realmId}/one-time-mappings',
    ...options
});

export const fulfillPayment = <ThrowOnError extends boolean = false>(options: Options<FulfillPaymentData, ThrowOnError>) => (options.client ?? client).post<FulfillPaymentResponses, FulfillPaymentErrors, ThrowOnError>({
    url: '/api/internal/bill/purchase/payment-attempts/{attemptId}/fulfill',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Caddy On-Demand TLS ask authorization endpoint.
 *
 * Returns `200 {"authorized": true}` when `host` matches a published+enabled
 * `custom_domain_mapping` row; `404` on a miss (Caddy declines TLS issuance); `401` when the
 * `X-Herald-Ask-Key` header is missing or mismatches the configured shared
 * secret. Never exposes realm information — this is a certificate-abuse gate.
 */
export const handleCustomDomainAuthorize = <ThrowOnError extends boolean = false>(options: Options<HandleCustomDomainAuthorizeData, ThrowOnError>) => (options.client ?? client).get<HandleCustomDomainAuthorizeResponses, HandleCustomDomainAuthorizeErrors, ThrowOnError>({ url: '/api/internal/custom-domain/authorize', ...options });

export const oidcRotateSigningKey = <ThrowOnError extends boolean = false>(options?: Options<OidcRotateSigningKeyData, ThrowOnError>) => (options?.client ?? client).post<OidcRotateSigningKeyResponses, OidcRotateSigningKeyErrors, ThrowOnError>({ url: '/api/internal/oidc/signing-key/rotate', ...options });

/**
 * List both agreement types with their source, current effective version, and
 * version history for the realm.
 *
 * Admin — requires first-party Bearer + `settings.view` + `has_access_to_realm`.
 * `source` is derived per-type from `has_custom` (Custom when a realm custom
 * version exists, otherwise Default).
 */
export const adminListAgreements = <ThrowOnError extends boolean = false>(options?: Options<AdminListAgreementsData, ThrowOnError>) => (options?.client ?? client).get<AdminListAgreementsResponses, AdminListAgreementsErrors, ThrowOnError>({ url: '/api/legal/admin/agreements', ...options });

/**
 * Get a single published version's full body by id (admin history view).
 *
 * Admin — requires first-party Bearer + `settings.view` (realm pinned by the session token)
 * (same gate as `admin_list_agreements`, since this is a read of the same
 * history the list already exposes). Returns 404 when the id does not resolve.
 * The `realmId` path segment scopes the permission check; the version itself is
 * looked up by primary key (history rows already surfaced by the list endpoint
 * are guaranteed to belong to the realm or be the platform default).
 */
export const adminGetVersion = <ThrowOnError extends boolean = false>(options: Options<AdminGetVersionData, ThrowOnError>) => (options.client ?? client).get<AdminGetVersionResponses, AdminGetVersionErrors, ThrowOnError>({ url: '/api/legal/admin/agreements/versions/{versionId}', ...options });

/**
 * Publish a new per-realm custom agreement version.
 *
 * Admin — requires first-party Bearer + `settings.manage` (realm pinned by the session token).
 * Unknown `agreementType` → 400; non-object/empty `content` → 400 (also
 * enforced in the service). On success the service records an
 * `agreement.published` audit event and returns the new version.
 */
export const adminPublishCustom = <ThrowOnError extends boolean = false>(options: Options<AdminPublishCustomData, ThrowOnError>) => (options.client ?? client).put<AdminPublishCustomResponses, AdminPublishCustomErrors, ThrowOnError>({
    url: '/api/legal/admin/agreements/{agreementType}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revert a realm's agreement to the platform default.
 *
 * Admin — requires first-party Bearer + `settings.manage` (realm pinned by the session token).
 * Implemented as **default-follow semantics** in the service: a realm-scoped
 * marker version is appended with `source = default` (new `version_id`,
 * monotonic `version_no`), after which effective resolution follows the
 * latest platform default rather than a frozen copy. History remains
 * append-only; no prior rows are deleted. The handler is a thin pass-through.
 */
export const adminRevertToDefault = <ThrowOnError extends boolean = false>(options: Options<AdminRevertToDefaultData, ThrowOnError>) => (options.client ?? client).delete<AdminRevertToDefaultResponses, AdminRevertToDefaultErrors, ThrowOnError>({ url: '/api/legal/admin/agreements/{agreementType}/custom', ...options });

/**
 * Discard the staged draft.
 *
 * Admin — requires first-party Bearer + `settings.manage` (realm pinned by the session token).
 * Idempotent: discarding a missing draft returns 204. The published version
 * table is untouched.
 */
export const adminDiscardDraft = <ThrowOnError extends boolean = false>(options: Options<AdminDiscardDraftData, ThrowOnError>) => (options.client ?? client).delete<AdminDiscardDraftResponses, AdminDiscardDraftErrors, ThrowOnError>({ url: '/api/legal/admin/agreements/{agreementType}/draft', ...options });

/**
 * Get the staged draft for an agreement type.
 *
 * Admin — requires first-party Bearer + `settings.manage` (realm pinned by the session token).
 * Returns 404 when no draft exists for the type (the admin form treats this as
 * "start a new draft").
 */
export const adminGetDraft = <ThrowOnError extends boolean = false>(options: Options<AdminGetDraftData, ThrowOnError>) => (options.client ?? client).get<AdminGetDraftResponses, AdminGetDraftErrors, ThrowOnError>({ url: '/api/legal/admin/agreements/{agreementType}/draft', ...options });

/**
 * Save (upsert) a draft for an agreement type.
 *
 * Admin — requires first-party Bearer + `settings.manage` (realm pinned by the session token).
 * A repeat save overwrites the prior draft. Does NOT publish — the agreement
 * stays unchanged for end users until POST `/publish`.
 */
export const adminSaveDraft = <ThrowOnError extends boolean = false>(options: Options<AdminSaveDraftData, ThrowOnError>) => (options.client ?? client).put<AdminSaveDraftResponses, AdminSaveDraftErrors, ThrowOnError>({
    url: '/api/legal/admin/agreements/{agreementType}/draft',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Publish the staged draft as a new effective version.
 *
 * Admin — requires first-party Bearer + `settings.manage` (realm pinned by the session token).
 * Reads the draft, creates a new immutable `legal_agreement_version` row
 * (advancing `version_no`, recording an `agreement.published` audit event),
 * and clears the draft. Returns 404 when no draft exists for the type. This is
 * the only path the admin UI uses to publish — there is no "publish without a
 * draft" entry in the UI (the legacy `PUT /agreements/{type}` handler remains
 * for backward compatibility).
 */
export const adminPublishFromDraft = <ThrowOnError extends boolean = false>(options: Options<AdminPublishFromDraftData, ThrowOnError>) => (options.client ?? client).post<AdminPublishFromDraftResponses, AdminPublishFromDraftErrors, ThrowOnError>({
    url: '/api/legal/admin/agreements/{agreementType}/publish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List the current effective agreements for a realm (Terms + Privacy).
 *
 * Public — no Bearer identity. Each agreement type resolves to its current
 * effective version (realm custom if present, otherwise platform default);
 * missing types are skipped. Returns 404 when no type resolves, which signals
 * a seed-missing deployment anomaly (the platform default templates should
 * always be present).
 */
export const listAgreements = <ThrowOnError extends boolean = false>(options: Options<ListAgreementsData, ThrowOnError>) => (options.client ?? client).get<ListAgreementsResponses, ListAgreementsErrors, ThrowOnError>({ url: '/api/legal/public/{realmId}/agreements', ...options });

/**
 * Get the full localized detail of a single agreement type for a realm.
 *
 * Public — no Bearer identity. Unknown `agreementType` → 400; no effective
 * version deployed → 404.
 */
export const getAgreement = <ThrowOnError extends boolean = false>(options: Options<GetAgreementData, ThrowOnError>) => (options.client ?? client).get<GetAgreementResponses, GetAgreementErrors, ThrowOnError>({ url: '/api/legal/public/{realmId}/agreements/{agreementType}', ...options });

/**
 * List all OAuth provider configurations for a realm
 */
export const listOauthConfigs = <ThrowOnError extends boolean = false>(options?: Options<ListOauthConfigsData, ThrowOnError>) => (options?.client ?? client).get<ListOauthConfigsResponses, ListOauthConfigsErrors, ThrowOnError>({ url: '/api/oauth-configs', ...options });

/**
 * Create OAuth provider configuration
 */
export const createOauthConfig = <ThrowOnError extends boolean = false>(options: Options<CreateOauthConfigData, ThrowOnError>) => (options.client ?? client).post<CreateOauthConfigResponses, CreateOauthConfigErrors, ThrowOnError>({
    url: '/api/oauth-configs',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete OAuth provider configuration
 */
export const deleteOauthConfig = <ThrowOnError extends boolean = false>(options: Options<DeleteOauthConfigData, ThrowOnError>) => (options.client ?? client).delete<DeleteOauthConfigResponses, DeleteOauthConfigErrors, ThrowOnError>({ url: '/api/oauth-configs/{providerType}', ...options });

/**
 * Get OAuth provider configuration by provider type
 */
export const getOauthConfig = <ThrowOnError extends boolean = false>(options: Options<GetOauthConfigData, ThrowOnError>) => (options.client ?? client).get<GetOauthConfigResponses, GetOauthConfigErrors, ThrowOnError>({ url: '/api/oauth-configs/{providerType}', ...options });

/**
 * Update OAuth provider configuration
 */
export const updateOauthConfig = <ThrowOnError extends boolean = false>(options: Options<UpdateOauthConfigData, ThrowOnError>) => (options.client ?? client).put<UpdateOauthConfigResponses, UpdateOauthConfigErrors, ThrowOnError>({
    url: '/api/oauth-configs/{providerType}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const oidcJwks = <ThrowOnError extends boolean = false>(options: Options<OidcJwksData, ThrowOnError>) => (options.client ?? client).get<OidcJwksResponses, OidcJwksErrors, ThrowOnError>({ url: '/api/oauth/{realmId}/.well-known/jwks.json', ...options });

export const oidcDiscovery = <ThrowOnError extends boolean = false>(options: Options<OidcDiscoveryData, ThrowOnError>) => (options.client ?? client).get<OidcDiscoveryResponses, OidcDiscoveryErrors, ThrowOnError>({ url: '/api/oauth/{realmId}/.well-known/openid-configuration', ...options });

/**
 * Apple native login.
 *
 * Verifies an Apple `identityToken` (from `ASAuthorizationAppleIDProvider`)
 * server-side and, depending on `downstreamState`, issues either a direct
 * browser session (Bearer token family bound to `clientId`) or a downstream
 * authorization code for the Code+PKCE flow. Requires the realm to have an
 * enabled Apple provider.
 */
export const appleNativeLogin = <ThrowOnError extends boolean = false>(options: Options<AppleNativeLoginData, ThrowOnError>) => (options.client ?? client).post<AppleNativeLoginResponses, AppleNativeLoginErrors, ThrowOnError>({
    url: '/api/oauth/{realmId}/apple/native-login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * OAuth authorize endpoint (Authorization Code + PKCE)
 *
 * Initiates the Authorization Code + PKCE flow:
 * 1. Validates client_id exists and is enabled
 * 2. Validates redirect_uri is in whitelist (exact match only)
 * 3. Validates PKCE code_challenge_method (must be S256 if provided)
 * 4. Stores state token with PKCE parameters in Redis (5 minutes TTL)
 * 5. Redirects to login page with OAuth parameters
 *
 * # Arguments
 * * `realm_id` - Realm identifier
 * * `params` - OAuth query parameters (client_id, redirect_uri, state, response_type, code_challenge, code_challenge_method)
 *
 * # Returns
 * * 302 redirect to login page with OAuth parameters
 *
 * # Errors
 * * 400 - Invalid parameters (missing client_id, redirect_uri, state, or code_challenge)
 * * 400 - Invalid response_type (must be "code")
 * * 400 - Unsupported code_challenge_method (must be "S256")
 * * 404 - Client not found
 * * 403 - Client app is disabled
 * * 400 - Redirect URI not in whitelist
 */
export const oauthAuthorize = <ThrowOnError extends boolean = false>(options: Options<OauthAuthorizeData, ThrowOnError>) => (options.client ?? client).get<unknown, OauthAuthorizeErrors, ThrowOnError>({ url: '/api/oauth/{realmId}/authorize', ...options });

/**
 * Google One Tap login.
 *
 * Verifies a Google One Tap (GIS) ID Token server-side and, depending on
 * `downstreamState`, issues either a direct browser session (Bearer token
 * family bound to `clientId`) or a downstream authorization code for the
 * Code+PKCE flow. Requires the realm to have an enabled Google provider.
 */
export const googleOneTap = <ThrowOnError extends boolean = false>(options: Options<GoogleOneTapData, ThrowOnError>) => (options.client ?? client).post<GoogleOneTapResponses, GoogleOneTapErrors, ThrowOnError>({
    url: '/api/oauth/{realmId}/google/one-tap',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * MCP dynamic client registration — gated pass-through form
 * (DEC-mcp-server-007). Advertised from the AS metadata as
 * `registration_endpoint` because mainstream MCP clients refuse to connect
 * without one; after the gate (rate limit + RFC 7591 shape + loopback
 * redirect validation) it returns the realm's preset public `herald-mcp`
 * client and persists NOTHING — the abuse surface therefore equals the
 * preset-client status quo (the real security boundaries stay in
 * authorize's loopback whitelist, mandatory PKCE, and the tool-layer
 * RBAC/scope gates).
 */
export const mcpClientRegistration = <ThrowOnError extends boolean = false>(options: Options<McpClientRegistrationData, ThrowOnError>) => (options.client ?? client).post<McpClientRegistrationResponses, McpClientRegistrationErrors, ThrowOnError>({
    url: '/api/oauth/{realmId}/mcp/register',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const oauthToken = <ThrowOnError extends boolean = false>(options: Options<OauthTokenData, ThrowOnError>) => (options.client ?? client).post<OauthTokenResponses, OauthTokenErrors, ThrowOnError>({
    url: '/api/oauth/{realmId}/token',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const oidcUserinfo = <ThrowOnError extends boolean = false>(options: Options<OidcUserinfoData, ThrowOnError>) => (options.client ?? client).post<OidcUserinfoResponses, OidcUserinfoErrors, ThrowOnError>({ url: '/api/oauth/{realmId}/userinfo', ...options });

/**
 * WeChat Mini Program login (code2session)
 */
export const wechatMiniprogramLogin = <ThrowOnError extends boolean = false>(options: Options<WechatMiniprogramLoginData, ThrowOnError>) => (options.client ?? client).post<WechatMiniprogramLoginResponses, WechatMiniprogramLoginErrors, ThrowOnError>({
    url: '/api/oauth/{realmId}/wechat-miniprogram/login',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Handle WeChat OAuth callback
 */
export const wechatCallback = <ThrowOnError extends boolean = false>(options: Options<WechatCallbackData, ThrowOnError>) => (options.client ?? client).get<unknown, WechatCallbackErrors, ThrowOnError>({ url: '/api/oauth/{realmId}/wechat/callback', ...options });

/**
 * Generate WeChat authorization URL (QRconnect)
 */
export const wechatLogin = <ThrowOnError extends boolean = false>(options: Options<WechatLoginData, ThrowOnError>) => (options.client ?? client).get<WechatLoginResponses, WechatLoginErrors, ThrowOnError>({ url: '/api/oauth/{realmId}/wechat/login', ...options });

/**
 * Handle OAuth callback from provider for a realm
 */
export const oauthCallback = <ThrowOnError extends boolean = false>(options: Options<OauthCallbackData, ThrowOnError>) => (options.client ?? client).get<OauthCallbackResponses, OauthCallbackErrors, ThrowOnError>({ url: '/api/oauth/{realmId}/{provider}/callback', ...options });

/**
 * Handle OAuth callback submitted as an HTML form (Apple `response_mode=form_post`
 * sends the authorization response as a POST body instead of a redirect query).
 * Same semantics as the GET variant.
 */
export const oauthCallbackForm = <ThrowOnError extends boolean = false>(options: Options<OauthCallbackFormData, ThrowOnError>) => (options.client ?? client).post<OauthCallbackFormResponses, OauthCallbackFormErrors, ThrowOnError>({
    ...urlSearchParamsBodySerializer,
    url: '/api/oauth/{realmId}/{provider}/callback',
    ...options,
    headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        ...options.headers
    }
});

/**
 * Initiate OAuth login flow for a realm
 */
export const oauthLogin = <ThrowOnError extends boolean = false>(options: Options<OauthLoginData, ThrowOnError>) => (options.client ?? client).get<OauthLoginResponses, OauthLoginErrors, ThrowOnError>({ url: '/api/oauth/{realmId}/{provider}/login', ...options });

/**
 * Permission check
 *
 * Spec: POST /api/permission/check
 */
export const checkPermission2 = <ThrowOnError extends boolean = false>(options: Options<CheckPermission2Data, ThrowOnError>) => (options.client ?? client).post<CheckPermission2Responses, CheckPermission2Errors, ThrowOnError>({
    url: '/api/permission/check',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List permissions in the realm
 *
 * List all permission definitions in the realm. Requires `permissions.view` permission.
 */
export const listPermissions = <ThrowOnError extends boolean = false>(options?: Options<ListPermissionsData, ThrowOnError>) => (options?.client ?? client).get<ListPermissionsResponses, ListPermissionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/permission/define',
    ...options
});

/**
 * Create a new permission
 *
 * Create a new permission definition. Permission name must be in format 'resource.action' (e.g., 'users.manage'). Requires `permissions.manage` permission.
 */
export const createPermissionDefinition = <ThrowOnError extends boolean = false>(options: Options<CreatePermissionDefinitionData, ThrowOnError>) => (options.client ?? client).post<CreatePermissionDefinitionResponses, CreatePermissionDefinitionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/permission/define',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a permission
 *
 * Delete a permission definition. Built-in permissions cannot be deleted. Requires `permissions.manage` permission.
 */
export const deletePermission = <ThrowOnError extends boolean = false>(options: Options<DeletePermissionData, ThrowOnError>) => (options.client ?? client).delete<DeletePermissionResponses, DeletePermissionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/permission/define/{permissionDefinitionId}',
    ...options
});

/**
 * Get permission by ID
 */
export const getPermission = <ThrowOnError extends boolean = false>(options: Options<GetPermissionData, ThrowOnError>) => (options.client ?? client).get<GetPermissionResponses, GetPermissionErrors, ThrowOnError>({ url: '/api/permission/define/{permissionDefinitionId}', ...options });

/**
 * Update a permission
 *
 * Update permission definition. Built-in permissions cannot be modified. Requires `permissions.manage` permission.
 */
export const updatePermission = <ThrowOnError extends boolean = false>(options: Options<UpdatePermissionData, ThrowOnError>) => (options.client ?? client).put<UpdatePermissionResponses, UpdatePermissionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/permission/define/{permissionDefinitionId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get role's policies
 *
 * Returns all permission policies for a specific role
 */
export const getRolePolicies = <ThrowOnError extends boolean = false>(options: Options<GetRolePoliciesData, ThrowOnError>) => (options.client ?? client).get<GetRolePoliciesResponses, GetRolePoliciesErrors, ThrowOnError>({ url: '/api/permission/roles/{roleId}/policies', ...options });

/**
 * Add policy to role
 *
 * Adds a permission policy to a role
 */
export const addPolicyToRole = <ThrowOnError extends boolean = false>(options: Options<AddPolicyToRoleData, ThrowOnError>) => (options.client ?? client).post<AddPolicyToRoleResponses, AddPolicyToRoleErrors, ThrowOnError>({
    url: '/api/permission/roles/{roleId}/policies',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove policy from role
 *
 * Removes a specific permission policy from a role
 */
export const removePolicyFromRole = <ThrowOnError extends boolean = false>(options: Options<RemovePolicyFromRoleData, ThrowOnError>) => (options.client ?? client).delete<RemovePolicyFromRoleResponses, RemovePolicyFromRoleErrors, ThrowOnError>({ url: '/api/permission/roles/{roleId}/policies/{policyId}', ...options });

/**
 * Get user's roles
 *
 * Returns all roles assigned to a specific user
 */
export const permissionGetUserRoles = <ThrowOnError extends boolean = false>(options: Options<PermissionGetUserRolesData, ThrowOnError>) => (options.client ?? client).get<PermissionGetUserRolesResponses, PermissionGetUserRolesErrors, ThrowOnError>({ url: '/api/permission/users/{userId}/roles', ...options });

/**
 * Assign roles to user
 *
 * Assigns one or more roles to a user
 */
export const assignRolesToUser = <ThrowOnError extends boolean = false>(options: Options<AssignRolesToUserData, ThrowOnError>) => (options.client ?? client).post<AssignRolesToUserResponses, AssignRolesToUserErrors, ThrowOnError>({
    url: '/api/permission/users/{userId}/roles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove role from user
 *
 * Removes a specific role from a user
 */
export const removeRoleFromUser = <ThrowOnError extends boolean = false>(options: Options<RemoveRoleFromUserData, ThrowOnError>) => (options.client ?? client).delete<RemoveRoleFromUserResponses, RemoveRoleFromUserErrors, ThrowOnError>({ url: '/api/permission/users/{userId}/roles/{roleId}', ...options });

/**
 * Grant points to a user (admin)
 */
export const grantPoints = <ThrowOnError extends boolean = false>(options: Options<GrantPointsData, ThrowOnError>) => (options.client ?? client).post<GrantPointsResponses, GrantPointsErrors, ThrowOnError>({
    url: '/api/points/grant',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the Realm's registration distribution rules.
 */
export const getRegistrationRules = <ThrowOnError extends boolean = false>(options?: Options<GetRegistrationRulesData, ThrowOnError>) => (options?.client ?? client).get<GetRegistrationRulesResponses, GetRegistrationRulesErrors, ThrowOnError>({ url: '/api/points/registration-rules', ...options });

/**
 * Atomically upsert the Realm's registration distribution rule set.
 */
export const upsertRegistrationRules = <ThrowOnError extends boolean = false>(options: Options<UpsertRegistrationRulesData, ThrowOnError>) => (options.client ?? client).put<UpsertRegistrationRulesResponses, UpsertRegistrationRulesErrors, ThrowOnError>({
    url: '/api/points/registration-rules',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Points consumption statistics for the admin statistics page.
 *
 * Requires the `points.view` permission. Consumption is attributed to the
 * transaction's creation day.
 */
export const getPointsConsumptionStats = <ThrowOnError extends boolean = false>(options?: Options<GetPointsConsumptionStatsData, ThrowOnError>) => (options?.client ?? client).get<GetPointsConsumptionStatsResponses, GetPointsConsumptionStatsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/points/stats/consumption',
    ...options
});

/**
 * List points transactions with filters
 */
export const listTransactions = <ThrowOnError extends boolean = false>(options?: Options<ListTransactionsData, ThrowOnError>) => (options?.client ?? client).get<ListTransactionsResponses, ListTransactionsErrors, ThrowOnError>({ url: '/api/points/transactions', ...options });

/**
 * List points wallets. Regular users see their own wallets; managers see all wallets in the realm.
 */
export const listWallets = <ThrowOnError extends boolean = false>(options?: Options<ListWalletsData, ThrowOnError>) => (options?.client ?? client).get<ListWalletsResponses, ListWalletsErrors, ThrowOnError>({ url: '/api/points/wallets', ...options });

/**
 * Get points wallet for a specific user
 */
export const getWallet = <ThrowOnError extends boolean = false>(options: Options<GetWalletData, ThrowOnError>) => (options.client ?? client).get<GetWalletResponses, GetWalletErrors, ThrowOnError>({ url: '/api/points/wallets/{userId}', ...options });

export const updateWalletStatus = <ThrowOnError extends boolean = false>(options: Options<UpdateWalletStatusData, ThrowOnError>) => (options.client ?? client).patch<UpdateWalletStatusResponses, UpdateWalletStatusErrors, ThrowOnError>({
    url: '/api/points/wallets/{userId}/{bucketId}/status',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Resolve the current request host to a published custom-domain realm.
 *
 * Used by the SPA on custom domains before it knows the realm id. This endpoint
 * is intentionally separate from the internal Caddy ask endpoint: the ask
 * endpoint stays shared-secret protected and never leaks realm identity, while
 * this public endpoint is only for hosts already serving the app.
 */
export const resolveCustomDomain = <ThrowOnError extends boolean = false>(options?: Options<ResolveCustomDomainData, ThrowOnError>) => (options?.client ?? client).get<ResolveCustomDomainResponses, ResolveCustomDomainErrors, ThrowOnError>({ url: '/api/public-config/custom-domain/resolve', ...options });

/**
 * Get public configuration for a realm
 *
 * Returns publicly accessible configuration for the specified realm, including:
 * - Registration settings (whether registration is allowed and if email verification is required)
 * - List of enabled OAuth providers
 * - Published white-label settings
 * - Whether the realm has a usable email channel
 *
 * This endpoint does not require authentication.
 */
export const getPublicConfig = <ThrowOnError extends boolean = false>(options: Options<GetPublicConfigData, ThrowOnError>) => (options.client ?? client).get<GetPublicConfigResponses, GetPublicConfigErrors, ThrowOnError>({ url: '/api/public-config/{realmId}', ...options });

/**
 * List all realms (non-paginated, deprecated - use list_realms_paginated)
 */
export const listRealms2 = <ThrowOnError extends boolean = false>(options?: Options<ListRealms2Data, ThrowOnError>) => (options?.client ?? client).get<ListRealms2Responses, ListRealms2Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/realms',
    ...options
});

/**
 * Create a new realm
 */
export const createRealm2 = <ThrowOnError extends boolean = false>(options: Options<CreateRealm2Data, ThrowOnError>) => (options.client ?? client).post<CreateRealm2Responses, CreateRealm2Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/realms',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * List realms with pagination
 */
export const listRealmsPaginated = <ThrowOnError extends boolean = false>(options?: Options<ListRealmsPaginatedData, ThrowOnError>) => (options?.client ?? client).get<ListRealmsPaginatedResponses, ListRealmsPaginatedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/realms/paginated',
    ...options
});

/**
 * Get realm by ID
 */
export const getRealm2 = <ThrowOnError extends boolean = false>(options: Options<GetRealm2Data, ThrowOnError>) => (options.client ?? client).get<GetRealm2Responses, GetRealm2Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/realms/{realmId}',
    ...options
});

/**
 * Update realm
 */
export const updateRealm = <ThrowOnError extends boolean = false>(options: Options<UpdateRealmData, ThrowOnError>) => (options.client ?? client).put<UpdateRealmResponses, UpdateRealmErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/realms/{realmId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get custom-domain management state.
 */
export const handleGetCustomDomainConfig = <ThrowOnError extends boolean = false>(options: Options<HandleGetCustomDomainConfigData, ThrowOnError>) => (options.client ?? client).get<HandleGetCustomDomainConfigResponses, HandleGetCustomDomainConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/realms/{realmId}/config/custom-domain',
    ...options
});

/**
 * Update custom-domain configuration (writes the host→realm mapping).
 */
export const handleUpdateCustomDomainConfig = <ThrowOnError extends boolean = false>(options: Options<HandleUpdateCustomDomainConfigData, ThrowOnError>) => (options.client ?? client).put<HandleUpdateCustomDomainConfigResponses, HandleUpdateCustomDomainConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/realms/{realmId}/config/custom-domain',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get realm Email OTP configuration
 *
 * Retrieves the Email OTP configuration (login enabled + auto-register) for a
 * realm. Requires 'settings.view' permission. Defaults to
 * `{ enabled: false, auto_register: false }` when no config exists.
 */
export const handleGetRealmEmailOtpConfig = <ThrowOnError extends boolean = false>(options: Options<HandleGetRealmEmailOtpConfigData, ThrowOnError>) => (options.client ?? client).get<HandleGetRealmEmailOtpConfigResponses, HandleGetRealmEmailOtpConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/realms/{realmId}/config/email-otp',
    ...options
});

/**
 * Update realm Email OTP configuration
 *
 * Enables/disables Email OTP login for a realm and separately controls whether
 * unregistered emails are auto-registered on successful verification. Requires
 * 'settings.manage' permission. Stored as `ConfigType::EmailOtp` /
 * `config_key="settings"` JSON.
 */
export const handleUpdateRealmEmailOtpConfig = <ThrowOnError extends boolean = false>(options: Options<HandleUpdateRealmEmailOtpConfigData, ThrowOnError>) => (options.client ?? client).put<HandleUpdateRealmEmailOtpConfigResponses, HandleUpdateRealmEmailOtpConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/realms/{realmId}/config/email-otp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get realm Passkey configuration
 *
 * Retrieves the Passkey configuration for a realm. Requires 'settings.view' permission.
 */
export const handleGetRealmPasskeyConfig = <ThrowOnError extends boolean = false>(options: Options<HandleGetRealmPasskeyConfigData, ThrowOnError>) => (options.client ?? client).get<HandleGetRealmPasskeyConfigResponses, HandleGetRealmPasskeyConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/realms/{realmId}/config/passkey',
    ...options
});

/**
 * Update realm Passkey configuration
 *
 * Updates the Passkey configuration for a realm, including whether Passkey authentication is enabled.
 * Requires 'settings.manage' permission.
 */
export const handleUpdateRealmPasskeyConfig = <ThrowOnError extends boolean = false>(options: Options<HandleUpdateRealmPasskeyConfigData, ThrowOnError>) => (options.client ?? client).put<HandleUpdateRealmPasskeyConfigResponses, HandleUpdateRealmPasskeyConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/realms/{realmId}/config/passkey',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get realm TOTP configuration and statistics
 *
 * Retrieves the TOTP configuration for a realm along with statistics about TOTP adoption
 * including total users, enabled users, disabled users, and enablement rate. Requires 'settings.view' permission.
 */
export const handleGetRealmTotpConfig = <ThrowOnError extends boolean = false>(options: Options<HandleGetRealmTotpConfigData, ThrowOnError>) => (options.client ?? client).get<HandleGetRealmTotpConfigResponses, HandleGetRealmTotpConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/realms/{realmId}/config/totp',
    ...options
});

/**
 * Update realm TOTP configuration
 *
 * Updates the TOTP (Time-based One-Time Password) configuration for a realm, including whether TOTP is enabled
 * and whether it is force-required for all users. Requires 'settings.manage' permission.
 */
export const handleUpdateRealmTotpConfig = <ThrowOnError extends boolean = false>(options: Options<HandleUpdateRealmTotpConfigData, ThrowOnError>) => (options.client ?? client).put<HandleUpdateRealmTotpConfigResponses, HandleUpdateRealmTotpConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/realms/{realmId}/config/totp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get white-label management state.
 */
export const handleGetWhiteLabelConfig = <ThrowOnError extends boolean = false>(options: Options<HandleGetWhiteLabelConfigData, ThrowOnError>) => (options.client ?? client).get<HandleGetWhiteLabelConfigResponses, HandleGetWhiteLabelConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/realms/{realmId}/config/white-label',
    ...options
});

/**
 * Discard white-label draft.
 */
export const handleDiscardWhiteLabelDraft = <ThrowOnError extends boolean = false>(options: Options<HandleDiscardWhiteLabelDraftData, ThrowOnError>) => (options.client ?? client).delete<HandleDiscardWhiteLabelDraftResponses, HandleDiscardWhiteLabelDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/realms/{realmId}/config/white-label/draft',
    ...options
});

/**
 * Save white-label draft without publishing.
 */
export const handleSaveWhiteLabelDraft = <ThrowOnError extends boolean = false>(options: Options<HandleSaveWhiteLabelDraftData, ThrowOnError>) => (options.client ?? client).put<HandleSaveWhiteLabelDraftResponses, HandleSaveWhiteLabelDraftErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/realms/{realmId}/config/white-label/draft',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Publish request body or the existing white-label draft.
 */
export const handlePublishWhiteLabelConfig = <ThrowOnError extends boolean = false>(options: Options<HandlePublishWhiteLabelConfigData, ThrowOnError>) => (options.client ?? client).post<HandlePublishWhiteLabelConfigResponses, HandlePublishWhiteLabelConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/realms/{realmId}/config/white-label/publish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Restore previous white-label settings.
 */
export const handleRestoreWhiteLabelConfig = <ThrowOnError extends boolean = false>(options: Options<HandleRestoreWhiteLabelConfigData, ThrowOnError>) => (options.client ?? client).post<HandleRestoreWhiteLabelConfigResponses, HandleRestoreWhiteLabelConfigErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/realms/{realmId}/config/white-label/restore',
    ...options
});

/**
 * List roles in the realm
 *
 * List all role definitions for the admin-web-console client. Requires `roles.view` permission.
 */
export const listRoles = <ThrowOnError extends boolean = false>(options?: Options<ListRolesData, ThrowOnError>) => (options?.client ?? client).get<ListRolesResponses, ListRolesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/roles/define',
    ...options
});

/**
 * Create a new role
 *
 * Create a new role definition. Requires `roles.manage` permission.
 */
export const createRole = <ThrowOnError extends boolean = false>(options: Options<CreateRoleData, ThrowOnError>) => (options.client ?? client).post<CreateRoleResponses, CreateRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/roles/define',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a role
 *
 * Delete a role definition. Built-in roles cannot be deleted. Requires `roles.manage` permission.
 */
export const deleteRole = <ThrowOnError extends boolean = false>(options: Options<DeleteRoleData, ThrowOnError>) => (options.client ?? client).delete<DeleteRoleResponses, DeleteRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/roles/define/{roleId}',
    ...options
});

/**
 * Get role by ID
 */
export const getRole = <ThrowOnError extends boolean = false>(options: Options<GetRoleData, ThrowOnError>) => (options.client ?? client).get<GetRoleResponses, GetRoleErrors, ThrowOnError>({ url: '/api/roles/define/{roleId}', ...options });

/**
 * Update a role
 *
 * Update role definition name and description. Requires `roles.manage` permission.
 */
export const updateRole = <ThrowOnError extends boolean = false>(options: Options<UpdateRoleData, ThrowOnError>) => (options.client ?? client).put<UpdateRoleResponses, UpdateRoleErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/roles/define/{roleId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get permissions for a role
 */
export const getRolePermissions = <ThrowOnError extends boolean = false>(options: Options<GetRolePermissionsData, ThrowOnError>) => (options.client ?? client).get<GetRolePermissionsResponses, GetRolePermissionsErrors, ThrowOnError>({ url: '/api/roles/define/{roleId}/permissions', ...options });

/**
 * Assign permission to role
 */
export const assignPermissionToRole = <ThrowOnError extends boolean = false>(options: Options<AssignPermissionToRoleData, ThrowOnError>) => (options.client ?? client).post<AssignPermissionToRoleResponses, AssignPermissionToRoleErrors, ThrowOnError>({
    url: '/api/roles/define/{roleId}/permissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Remove permission from role
 */
export const removePermissionFromRole = <ThrowOnError extends boolean = false>(options: Options<RemovePermissionFromRoleData, ThrowOnError>) => (options.client ?? client).delete<RemovePermissionFromRoleResponses, RemovePermissionFromRoleErrors, ThrowOnError>({ url: '/api/roles/define/{roleId}/permissions/{permissionId}', ...options });

export const handleAppleWebhook = <ThrowOnError extends boolean = false>(options: Options<HandleAppleWebhookData, ThrowOnError>) => (options.client ?? client).post<HandleAppleWebhookResponses, unknown, ThrowOnError>({ url: '/api/third/pay/{realmId}/apple/webhooks', ...options });

/**
 * Handle Creem webhook events
 *
 * Verifies signature, checks idempotency, routes to appropriate handler,
 * and returns 200 OK. Processing happens synchronously.
 */
export const creemWebhookHandler = <ThrowOnError extends boolean = false>(options: Options<CreemWebhookHandlerData, ThrowOnError>) => (options.client ?? client).post<CreemWebhookHandlerResponses, CreemWebhookHandlerErrors, ThrowOnError>({
    bodySerializer: null,
    url: '/api/third/pay/{realmId}/creem/webhooks',
    ...options,
    headers: {
        'Content-Type': 'text/plain',
        ...options.headers
    }
});

/**
 * Handle Stripe webhook events
 *
 * Verifies signature, checks idempotency, routes to appropriate handler,
 * and returns 200 OK. Processing happens synchronously (for now).
 */
export const stripeWebhookHandler = <ThrowOnError extends boolean = false>(options: Options<StripeWebhookHandlerData, ThrowOnError>) => (options.client ?? client).post<StripeWebhookHandlerResponses, StripeWebhookHandlerErrors, ThrowOnError>({
    bodySerializer: null,
    url: '/api/third/pay/{realmId}/stripe/webhooks',
    ...options,
    headers: {
        'Content-Type': 'text/plain',
        ...options.headers
    }
});

export const wechatWebhookHandler = <ThrowOnError extends boolean = false>(options: Options<WechatWebhookHandlerData, ThrowOnError>) => (options.client ?? client).post<WechatWebhookHandlerResponses, WechatWebhookHandlerErrors, ThrowOnError>({ url: '/api/third/pay/{realmId}/wechat/webhooks', ...options });

/**
 * Self-service account deletion (soft-delete).
 *
 * Requires an authenticated browser token. Anonymizes PII,
 * marks the account `Deleted`, clears TOTP, cancels in-effect subscriptions,
 * revokes all sessions (incl. the caller's), and records a `user.delete`
 * audit event. One-time purchases are NOT refunded. Returns 204 on success —
 * the caller's token is invalidated by the session wipe.
 */
export const deleteAccount = <ThrowOnError extends boolean = false>(options: Options<DeleteAccountData, ThrowOnError>) => (options.client ?? client).delete<DeleteAccountResponses, DeleteAccountErrors, ThrowOnError>({
    url: '/api/user',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listMyInvoices = <ThrowOnError extends boolean = false>(options?: Options<ListMyInvoicesData, ThrowOnError>) => (options?.client ?? client).get<ListMyInvoicesResponses, ListMyInvoicesErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/bill/invoices',
    ...options
});

export const applyInvoice = <ThrowOnError extends boolean = false>(options: Options<ApplyInvoiceData, ThrowOnError>) => (options.client ?? client).post<ApplyInvoiceResponses, ApplyInvoiceErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/bill/invoices',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Per-resource invoice apply-eligibility (read-only, context-level).
 *
 * Decision order: ownership → provider → policy → seller config →
 * external-invoice-exists, then delegates the verdict to the pure
 * `determine_invoice_apply_route`. The endpoint resolves facts; the pure
 * function owns the rules (single home — avoids divergence from the write
 * path `validate_invoice_creation_policy` / `apply_invoice`).
 */
export const getInvoiceApplyEligibility = <ThrowOnError extends boolean = false>(options: Options<GetInvoiceApplyEligibilityData, ThrowOnError>) => (options.client ?? client).get<GetInvoiceApplyEligibilityResponses, GetInvoiceApplyEligibilityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/bill/invoices/apply-eligibility',
    ...options
});

export const getMyInvoiceScoped = <ThrowOnError extends boolean = false>(options: Options<GetMyInvoiceScopedData, ThrowOnError>) => (options.client ?? client).get<GetMyInvoiceScopedResponses, GetMyInvoiceScopedErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/bill/invoices/{invoiceId}',
    ...options
});

export const downloadMyInvoicePdf = <ThrowOnError extends boolean = false>(options: Options<DownloadMyInvoicePdfData, ThrowOnError>) => (options.client ?? client).get<DownloadMyInvoicePdfResponses, DownloadMyInvoicePdfErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/bill/invoices/{invoiceId}/pdf',
    ...options
});

export const getPurchaseHistory = <ThrowOnError extends boolean = false>(options?: Options<GetPurchaseHistoryData, ThrowOnError>) => (options?.client ?? client).get<GetPurchaseHistoryResponses, GetPurchaseHistoryErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/bill/purchase/history',
    ...options
});

/**
 * Change password for current user
 */
export const changeUserPassword = <ThrowOnError extends boolean = false>(options: Options<ChangeUserPasswordData, ThrowOnError>) => (options.client ?? client).post<ChangeUserPasswordResponses, ChangeUserPasswordErrors, ThrowOnError>({
    url: '/api/user/change-password',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Record the user's explicit consent to one or more agreement versions.
 *
 * Self-service — requires Bearer identity; the realm is the one pinned by
 * the bearer token. Each `version_id` must equal the
 * current effective version for its type (enforced in the service layer,
 * BE-D04); a stale version surfaces as 409 so the client re-reads the
 * effective version. Returns 204 on success. The upsert is idempotent on a
 * repeat of the same version.
 */
export const recordConsent = <ThrowOnError extends boolean = false>(options: Options<RecordConsentData, ThrowOnError>) => (options.client ?? client).post<RecordConsentResponses, RecordConsentErrors, ThrowOnError>({
    url: '/api/user/consent',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reconsent gate verdict for the calling user across both agreement types.
 *
 * Self-service — requires Bearer identity. The realm is the one pinned by
 * the bearer token (each user may only inspect their own realm's consent
 * state).
 */
export const getConsentStatus = <ThrowOnError extends boolean = false>(options?: Options<GetConsentStatusData, ThrowOnError>) => (options?.client ?? client).get<GetConsentStatusResponses, GetConsentStatusErrors, ThrowOnError>({ url: '/api/user/consent/status', ...options });

export const getUserFeatureAvailability = <ThrowOnError extends boolean = false>(options?: Options<GetUserFeatureAvailabilityData, ThrowOnError>) => (options?.client ?? client).get<GetUserFeatureAvailabilityResponses, GetUserFeatureAvailabilityErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/feature-availability',
    ...options
});

export const handleListPasskeyCredentials = <ThrowOnError extends boolean = false>(options?: Options<HandleListPasskeyCredentialsData, ThrowOnError>) => (options?.client ?? client).get<HandleListPasskeyCredentialsResponses, HandleListPasskeyCredentialsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/passkey/credentials',
    ...options
});

export const handleDeletePasskeyCredential = <ThrowOnError extends boolean = false>(options: Options<HandleDeletePasskeyCredentialData, ThrowOnError>) => (options.client ?? client).delete<HandleDeletePasskeyCredentialResponses, HandleDeletePasskeyCredentialErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/passkey/credentials/{credentialId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const handleRenamePasskeyCredential = <ThrowOnError extends boolean = false>(options: Options<HandleRenamePasskeyCredentialData, ThrowOnError>) => (options.client ?? client).patch<HandleRenamePasskeyCredentialResponses, HandleRenamePasskeyCredentialErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/passkey/credentials/{credentialId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const handleBeginPasskeyRegistration = <ThrowOnError extends boolean = false>(options: Options<HandleBeginPasskeyRegistrationData, ThrowOnError>) => (options.client ?? client).post<HandleBeginPasskeyRegistrationResponses, HandleBeginPasskeyRegistrationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/passkey/registration/begin',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const handleFinishPasskeyRegistration = <ThrowOnError extends boolean = false>(options: Options<HandleFinishPasskeyRegistrationData, ThrowOnError>) => (options.client ?? client).post<HandleFinishPasskeyRegistrationResponses, HandleFinishPasskeyRegistrationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/passkey/registration/finish',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the current user's permission list
 *
 * Returns the list of all permission names the current user has, used for
 * frontend menu permission control.
 *
 * **has_all field**:
 * Legacy response field kept for compatibility. The user endpoint no longer
 * expands the full set of realm permission definitions and always returns false.
 */
export const getCurrentUserPermissions = <ThrowOnError extends boolean = false>(options?: Options<GetCurrentUserPermissionsData, ThrowOnError>) => (options?.client ?? client).get<GetCurrentUserPermissionsResponses, GetCurrentUserPermissionsErrors, ThrowOnError>({ url: '/api/user/permissions', ...options });

/**
 * Get current user profile
 */
export const getProfile = <ThrowOnError extends boolean = false>(options?: Options<GetProfileData, ThrowOnError>) => (options?.client ?? client).get<GetProfileResponses, GetProfileErrors, ThrowOnError>({ url: '/api/user/profile', ...options });

/**
 * Update current user profile
 */
export const updateProfile = <ThrowOnError extends boolean = false>(options: Options<UpdateProfileData, ThrowOnError>) => (options.client ?? client).put<UpdateProfileResponses, UpdateProfileErrors, ThrowOnError>({
    url: '/api/user/profile',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const handleBeginReauth = <ThrowOnError extends boolean = false>(options: Options<HandleBeginReauthData, ThrowOnError>) => (options.client ?? client).post<HandleBeginReauthResponses, HandleBeginReauthErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/reauth',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const handleVerifyReauth = <ThrowOnError extends boolean = false>(options: Options<HandleVerifyReauthData, ThrowOnError>) => (options.client ?? client).post<HandleVerifyReauthResponses, HandleVerifyReauthErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/reauth/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the current user's roles and permissions
 *
 * Returns all roles (role names) and permissions (permission names) of the
 * currently logged-in user. Returns the roles and permissions the user
 * actually holds, without expanding the full set of realm permission definitions.
 */
export const getUserRoles = <ThrowOnError extends boolean = false>(options?: Options<GetUserRolesData, ThrowOnError>) => (options?.client ?? client).get<GetUserRolesResponses, GetUserRolesErrors, ThrowOnError>({ url: '/api/user/roles', ...options });

/**
 * Disable TOTP two-factor authentication for the current user
 *
 * Disables TOTP and removes the configuration. Requires a single-use reauth
 * ticket obtained by verifying any one of the user's factors (password, TOTP,
 * or Passkey) via `POST /api/user/reauth/verify` (see `consume_reauth`).
 * Cannot be disabled if the realm has force-enabled TOTP.
 */
export const handleDisableTotp = <ThrowOnError extends boolean = false>(options: Options<HandleDisableTotpData, ThrowOnError>) => (options.client ?? client).delete<HandleDisableTotpResponses, HandleDisableTotpErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/totp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Enable TOTP two-factor authentication for the current user
 *
 * Initiates TOTP setup by generating a secret key, QR code URL, and backup codes.
 * The user must verify the TOTP code to complete the setup. Requires a single-use
 * reauth ticket obtained by verifying any one of the user's factors (password,
 * TOTP, or Passkey) via `POST /api/user/reauth/verify` (see `consume_reauth`).
 */
export const handleEnableTotp = <ThrowOnError extends boolean = false>(options: Options<HandleEnableTotpData, ThrowOnError>) => (options.client ?? client).post<HandleEnableTotpResponses, HandleEnableTotpErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/totp',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Regenerate TOTP secret and backup codes
 *
 * Generates a new TOTP secret and backup codes, staged for swap: the old
 * secret and backup codes remain valid until the user verifies a code from
 * the new secret; abandoning the flow (or a failed verification) leaves them
 * intact, so 2FA is never silently disabled. Requires
 * a single-use reauth ticket obtained by verifying any one of the user's factors
 * (password, TOTP, or Passkey) via `POST /api/user/reauth/verify` (see `consume_reauth`).
 */
export const handleRegenerateTotp = <ThrowOnError extends boolean = false>(options: Options<HandleRegenerateTotpData, ThrowOnError>) => (options.client ?? client).post<HandleRegenerateTotpResponses, HandleRegenerateTotpErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/totp/regenerate',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get TOTP configuration status for the current user
 *
 * Returns the TOTP status including whether it is enabled, when it was enabled,
 * and backup code usage statistics.
 */
export const handleGetTotpStatus = <ThrowOnError extends boolean = false>(options?: Options<HandleGetTotpStatusData, ThrowOnError>) => (options?.client ?? client).get<HandleGetTotpStatusResponses, HandleGetTotpStatusErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/totp/status',
    ...options
});

/**
 * Verify TOTP setup and enable two-factor authentication
 *
 * Completes the TOTP setup process by verifying the TOTP code generated from the secret.
 * On successful verification, TOTP is enabled for the user account.
 */
export const handleVerifyTotpSetup = <ThrowOnError extends boolean = false>(options: Options<HandleVerifyTotpSetupData, ThrowOnError>) => (options.client ?? client).post<HandleVerifyTotpSetupResponses, HandleVerifyTotpSetupErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/totp/verify',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

export const listUserTransactions = <ThrowOnError extends boolean = false>(options?: Options<ListUserTransactionsData, ThrowOnError>) => (options?.client ?? client).get<ListUserTransactionsResponses, ListUserTransactionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/transactions',
    ...options
});

export const listUserWallets = <ThrowOnError extends boolean = false>(options?: Options<ListUserWalletsData, ThrowOnError>) => (options?.client ?? client).get<ListUserWalletsResponses, ListUserWalletsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/user/wallets',
    ...options
});

/**
 * List users in the realm
 *
 * List users with pagination. Requires `users.view` permission.
 */
export const listUsers2 = <ThrowOnError extends boolean = false>(options?: Options<ListUsers2Data, ThrowOnError>) => (options?.client ?? client).get<ListUsers2Responses, ListUsers2Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users',
    ...options
});

/**
 * Create a new user
 *
 * Create a new user with email, password, and optional roles. Requires `users.manage` permission. Realm-admins can only assign the 'user' role unless they also have `roles.manage` permission.
 */
export const createUser2 = <ThrowOnError extends boolean = false>(options: Options<CreateUser2Data, ThrowOnError>) => (options.client ?? client).post<CreateUser2Responses, CreateUser2Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Delete a user
 *
 * Delete a user from the realm. Requires `users.manage` permission.
 */
export const deleteUser = <ThrowOnError extends boolean = false>(options: Options<DeleteUserData, ThrowOnError>) => (options.client ?? client).delete<DeleteUserResponses, DeleteUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/{userId}',
    ...options
});

/**
 * Get user by ID
 *
 * Get detailed information about a specific user. Requires `users.view` permission. Cross-realm targets return 404 (indistinguishable from missing).
 */
export const getUser2 = <ThrowOnError extends boolean = false>(options: Options<GetUser2Data, ThrowOnError>) => (options.client ?? client).get<GetUser2Responses, GetUser2Errors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/{userId}',
    ...options
});

/**
 * Update a user
 *
 * Update user status or nickname. Email is read-only after creation. Requires `users.manage` permission.
 */
export const updateUser = <ThrowOnError extends boolean = false>(options: Options<UpdateUserData, ThrowOnError>) => (options.client ?? client).put<UpdateUserResponses, UpdateUserErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/{userId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get user's effective permissions
 *
 * Returns all permissions a user has, including:
 * - Permissions directly assigned to the user
 * - Permissions inherited from roles
 *
 * Each permission includes its source (role name or "direct").
 */
export const getEffectivePermissions = <ThrowOnError extends boolean = false>(options: Options<GetEffectivePermissionsData, ThrowOnError>) => (options.client ?? client).get<GetEffectivePermissionsResponses, GetEffectivePermissionsErrors, ThrowOnError>({ url: '/api/users/{userId}/effective-permissions', ...options });

/**
 * Remove direct permission from user
 *
 * Removes a directly assigned permission from a user.
 */
export const removeUserPermission = <ThrowOnError extends boolean = false>(options: Options<RemoveUserPermissionData, ThrowOnError>) => (options.client ?? client).delete<RemoveUserPermissionResponses, RemoveUserPermissionErrors, ThrowOnError>({
    url: '/api/users/{userId}/permissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get user's directly assigned permissions
 *
 * Returns permissions that were directly assigned to the user (not through roles).
 * These are policies where the subject is the user_id itself.
 *
 * **Note**: This endpoint returns only direct permissions. For effective permissions
 * (including those inherited from roles), use `/effective-permissions`.
 */
export const getUserPermissions = <ThrowOnError extends boolean = false>(options: Options<GetUserPermissionsData, ThrowOnError>) => (options.client ?? client).get<GetUserPermissionsResponses, GetUserPermissionsErrors, ThrowOnError>({ url: '/api/users/{userId}/permissions', ...options });

/**
 * Assign direct permission to user
 *
 * Assigns a permission directly to a user (bypassing roles).
 *
 * **Security constraints**:
 * - Requires policies.manage permission
 * - Cannot create "All" or wildcard policies (privileged policies)
 */
export const assignUserPermission = <ThrowOnError extends boolean = false>(options: Options<AssignUserPermissionData, ThrowOnError>) => (options.client ?? client).post<AssignUserPermissionResponses, AssignUserPermissionErrors, ThrowOnError>({
    url: '/api/users/{userId}/permissions',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Reset user password (generate 16-character random password)
 */
export const resetUserPassword = <ThrowOnError extends boolean = false>(options: Options<ResetUserPasswordData, ThrowOnError>) => (options.client ?? client).post<ResetUserPasswordResponses, ResetUserPasswordErrors, ThrowOnError>({ url: '/api/users/{userId}/reset-password', ...options });

/**
 * Get user roles
 *
 * Returns the list of roles assigned to a specific user.
 */
export const adminGetUserRoles = <ThrowOnError extends boolean = false>(options: Options<AdminGetUserRolesData, ThrowOnError>) => (options.client ?? client).get<AdminGetUserRolesResponses, AdminGetUserRolesErrors, ThrowOnError>({ url: '/api/users/{userId}/roles', ...options });

/**
 * Update user roles
 *
 * Updates the roles assigned to a user. Replaces all existing roles with the new list.
 *
 * **Security constraints**:
 * - Realm-admin can only assign "user" role, not "realm-admin"
 */
export const updateUserRoles = <ThrowOnError extends boolean = false>(options: Options<UpdateUserRolesData, ThrowOnError>) => (options.client ?? client).put<UpdateUserRolesResponses, UpdateUserRolesErrors, ThrowOnError>({
    url: '/api/users/{userId}/roles',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Revoke all sessions for a user
 *
 * Revoke every active browser-token session for a user. Requires `users.manage` permission.
 */
export const revokeAllUserSessions = <ThrowOnError extends boolean = false>(options: Options<RevokeAllUserSessionsData, ThrowOnError>) => (options.client ?? client).delete<RevokeAllUserSessionsResponses, RevokeAllUserSessionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/{userId}/sessions',
    ...options
});

/**
 * List a user's active sessions
 *
 * List active browser-token sessions for a specific user. Requires `users.manage` permission.
 */
export const listUserSessions = <ThrowOnError extends boolean = false>(options: Options<ListUserSessionsData, ThrowOnError>) => (options.client ?? client).get<ListUserSessionsResponses, ListUserSessionsErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/{userId}/sessions',
    ...options
});

/**
 * Revoke a single user session
 *
 * Revoke a single browser-token session family for a user. Requires `users.manage` permission.
 */
export const revokeUserSession = <ThrowOnError extends boolean = false>(options: Options<RevokeUserSessionData, ThrowOnError>) => (options.client ?? client).delete<RevokeUserSessionResponses, RevokeUserSessionErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/api/users/{userId}/sessions/{familyId}',
    ...options
});

/**
 * Health check endpoint for monitoring and orchestration
 *
 * Used by:
 * - Kubernetes liveness probes (is the service running?)
 * - Kubernetes readiness probes (can the service handle traffic?)
 * - Monitoring systems (Prometheus, Datadog, etc.)
 * - Load balancers (health checks)
 *
 * # Health Criteria
 *
 * The service is considered **healthy** when:
 * - PostgreSQL database is reachable (`SELECT 1` succeeds)
 * - Redis cache is reachable (PING succeeds)
 *
 * # Response Codes
 *
 * - **200 OK**: Service is healthy
 * - **503 Service Unavailable**: Service is unhealthy
 */
export const healthCheck = <ThrowOnError extends boolean = false>(options?: Options<HealthCheckData, ThrowOnError>) => (options?.client ?? client).get<HealthCheckResponses, HealthCheckErrors, ThrowOnError>({ url: '/health', ...options });
